// Generated by scripts/enrich-insert-variants.js — do not edit by hand.
// Last run: 2026-06-08T15:51:45.764Z

import {
  INSERT_CONTOUR_SEMI_CERISE,
  INSERT_CONTOUR_SUPERSOFT,
  INSERT_JOPO_OVAL,
  INSERT_JOPO_OVAL_DOTS,
  INSERT_JOPO_POWER_FLAT,
  INSERT_JOPO_POWER_LIFT,
  INSERT_JOPO_POWER_OVAL,
  INSERT_TURBO_MISS_QUAD_OVAL,
  INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  INSERT_TURBO_QUAD_2_OVAL_NUBS,
  INSERT_TURBO_QUAD_2_SEMI,
  INSERT_TURBO_QUAD_CLASSIC_OVAL,
  INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  INSERT_TURBO_QUAD_OVAL,
  INSERT_TURBO_QUAD_OVAL_MESH,
  INSERT_TURBO_QUAD_POWER_OVAL,
  INSERT_TURBO_QUAD_SB_POWER_LIFT,
  INSERT_TURBO_QUAD_SB_SEMI,
  INSERT_ULTIMATE_TLO_LIFT,
  INSERT_ULTIMATE_TLO_LIFT_7_8,
  INSERT_ULTIMATE_TLO_OVAL,
  INSERT_ULTIMATE_TLO_OVAL_7_8,
  INSERT_VISE_GRAPE_NUBS,
  INSERT_VISE_OVAL,
  INSERT_VISE_OVAL_7_8,
  INSERT_VISE_POWER_LIFT,
  INSERT_VISE_POWER_LIFT_7_8,
  INSERT_VISE_POWER_OVAL,
  INSERT_VISE_POWER_OVAL_7_8,
  INSERT_VISE_SEMI,
  INSERT_VISE_SEMI_7_8,
  INSERT_VISE_SILICONE,
} from "./idx_data_insert_types";

export const idx_data_insert_variants = [];

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-01" },
    { color: "BLUE", upc: "TUR-INSQ1-08-01" },
    { color: "GREEN", upc: "TUR-INSQ1-04-01" },
    { color: "ICE", upc: "TUR-INSQ1-01-01" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-01" },
    { color: "PINK", upc: "TUR-INSQ1-10-01" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-01" },
    { color: "RED", upc: "TUR-INSQ1-09-01" },
    { color: "WHITE", upc: "TUR-INSQ1-03-01" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-02" },
    { color: "BLUE", upc: "TUR-INSQ1-08-02" },
    { color: "GREEN", upc: "TUR-INSQ1-04-02" },
    { color: "ICE", upc: "TUR-INSQ1-01-02" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-02" },
    { color: "PINK", upc: "TUR-INSQ1-10-02" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-02" },
    { color: "RED", upc: "TUR-INSQ1-09-02" },
    { color: "WHITE", upc: "TUR-INSQ1-03-02" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-03" },
    { color: "BLUE", upc: "TUR-INSQ1-08-03" },
    { color: "GREEN", upc: "TUR-INSQ1-04-03" },
    { color: "ICE", upc: "TUR-INSQ1-01-03" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-03" },
    { color: "PINK", upc: "TUR-INSQ1-10-03" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-03" },
    { color: "RED", upc: "TUR-INSQ1-09-03" },
    { color: "WHITE", upc: "TUR-INSQ1-03-03" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-04" },
    { color: "BLUE", upc: "TUR-INSQ1-08-04" },
    { color: "GREEN", upc: "TUR-INSQ1-04-04" },
    { color: "ICE", upc: "TUR-INSQ1-01-04" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-04" },
    { color: "PINK", upc: "TUR-INSQ1-10-04" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-04" },
    { color: "RED", upc: "TUR-INSQ1-09-04" },
    { color: "WHITE", upc: "TUR-INSQ1-03-04" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-05" },
    { color: "BLUE", upc: "TUR-INSQ1-08-05" },
    { color: "GREEN", upc: "TUR-INSQ1-04-05" },
    { color: "ICE", upc: "TUR-INSQ1-01-05" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-05" },
    { color: "PINK", upc: "TUR-INSQ1-10-05" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-05" },
    { color: "RED", upc: "TUR-INSQ1-09-05" },
    { color: "WHITE", upc: "TUR-INSQ1-03-05" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-06" },
    { color: "BLUE", upc: "TUR-INSQ1-08-06" },
    { color: "GREEN", upc: "TUR-INSQ1-04-06" },
    { color: "ICE", upc: "TUR-INSQ1-01-06" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-06" },
    { color: "PINK", upc: "TUR-INSQ1-10-06" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-06" },
    { color: "RED", upc: "TUR-INSQ1-09-06" },
    { color: "WHITE", upc: "TUR-INSQ1-03-06" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-07" },
    { color: "BLUE", upc: "TUR-INSQ1-08-07" },
    { color: "GREEN", upc: "TUR-INSQ1-04-07" },
    { color: "ICE", upc: "TUR-INSQ1-01-07" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-07" },
    { color: "PINK", upc: "TUR-INSQ1-10-07" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-07" },
    { color: "RED", upc: "TUR-INSQ1-09-07" },
    { color: "WHITE", upc: "TUR-INSQ1-03-07" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-08" },
    { color: "BLUE", upc: "TUR-INSQ1-08-08" },
    { color: "GREEN", upc: "TUR-INSQ1-04-08" },
    { color: "ICE", upc: "TUR-INSQ1-01-08" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-08" },
    { color: "PINK", upc: "TUR-INSQ1-10-08" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-08" },
    { color: "RED", upc: "TUR-INSQ1-09-08" },
    { color: "WHITE", upc: "TUR-INSQ1-03-08" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-09" },
    { color: "BLUE", upc: "TUR-INSQ1-08-09" },
    { color: "GREEN", upc: "TUR-INSQ1-04-09" },
    { color: "ICE", upc: "TUR-INSQ1-01-09" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-09" },
    { color: "PINK", upc: "TUR-INSQ1-10-09" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-09" },
    { color: "RED", upc: "TUR-INSQ1-09-09" },
    { color: "WHITE", upc: "TUR-INSQ1-03-09" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-10" },
    { color: "BLUE", upc: "TUR-INSQ1-08-10" },
    { color: "GREEN", upc: "TUR-INSQ1-04-10" },
    { color: "ICE", upc: "TUR-INSQ1-01-10" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-10" },
    { color: "PINK", upc: "TUR-INSQ1-10-10" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-10" },
    { color: "RED", upc: "TUR-INSQ1-09-10" },
    { color: "WHITE", upc: "TUR-INSQ1-03-10" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-11" },
    { color: "BLUE", upc: "TUR-INSQ1-08-11" },
    { color: "GREEN", upc: "TUR-INSQ1-04-11" },
    { color: "ICE", upc: "TUR-INSQ1-01-11" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-11" },
    { color: "PINK", upc: "TUR-INSQ1-10-11" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-11" },
    { color: "RED", upc: "TUR-INSQ1-09-11" },
    { color: "WHITE", upc: "TUR-INSQ1-03-11" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-12" },
    { color: "BLUE", upc: "TUR-INSQ1-08-12" },
    { color: "GREEN", upc: "TUR-INSQ1-04-12" },
    { color: "ICE", upc: "TUR-INSQ1-01-12" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-12" },
    { color: "PINK", upc: "TUR-INSQ1-10-12" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-12" },
    { color: "RED", upc: "TUR-INSQ1-09-12" },
    { color: "WHITE", upc: "TUR-INSQ1-03-12" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-13" },
    { color: "BLUE", upc: "TUR-INSQ1-08-13" },
    { color: "GREEN", upc: "TUR-INSQ1-04-13" },
    { color: "ICE", upc: "TUR-INSQ1-01-13" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-13" },
    { color: "PINK", upc: "TUR-INSQ1-10-13" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-13" },
    { color: "RED", upc: "TUR-INSQ1-09-13" },
    { color: "WHITE", upc: "TUR-INSQ1-03-13" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-14" },
    { color: "BLUE", upc: "TUR-INSQ1-08-14" },
    { color: "GREEN", upc: "TUR-INSQ1-04-14" },
    { color: "ICE", upc: "TUR-INSQ1-01-14" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-14" },
    { color: "PINK", upc: "TUR-INSQ1-10-14" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-14" },
    { color: "RED", upc: "TUR-INSQ1-09-14" },
    { color: "WHITE", upc: "TUR-INSQ1-03-14" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-15" },
    { color: "BLUE", upc: "TUR-INSQ1-08-15" },
    { color: "GREEN", upc: "TUR-INSQ1-04-15" },
    { color: "ICE", upc: "TUR-INSQ1-01-15" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-15" },
    { color: "PINK", upc: "TUR-INSQ1-10-15" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-15" },
    { color: "RED", upc: "TUR-INSQ1-09-15" },
    { color: "WHITE", upc: "TUR-INSQ1-03-15" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-16" },
    { color: "BLUE", upc: "TUR-INSQ1-08-16" },
    { color: "GREEN", upc: "TUR-INSQ1-04-16" },
    { color: "ICE", upc: "TUR-INSQ1-01-16" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-16" },
    { color: "PINK", upc: "TUR-INSQ1-10-16" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-16" },
    { color: "RED", upc: "TUR-INSQ1-09-16" },
    { color: "WHITE", upc: "TUR-INSQ1-03-16" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-17" },
    { color: "BLUE", upc: "TUR-INSQ1-08-17" },
    { color: "GREEN", upc: "TUR-INSQ1-04-17" },
    { color: "ICE", upc: "TUR-INSQ1-01-17" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-17" },
    { color: "PINK", upc: "TUR-INSQ1-10-17" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-17" },
    { color: "RED", upc: "TUR-INSQ1-09-17" },
    { color: "WHITE", upc: "TUR-INSQ1-03-17" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-18" },
    { color: "BLUE", upc: "TUR-INSQ1-08-18" },
    { color: "GREEN", upc: "TUR-INSQ1-04-18" },
    { color: "ICE", upc: "TUR-INSQ1-01-18" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-18" },
    { color: "PINK", upc: "TUR-INSQ1-10-18" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-18" },
    { color: "RED", upc: "TUR-INSQ1-09-18" },
    { color: "WHITE", upc: "TUR-INSQ1-03-18" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-19" },
    { color: "BLUE", upc: "TUR-INSQ1-08-19" },
    { color: "GREEN", upc: "TUR-INSQ1-04-19" },
    { color: "ICE", upc: "TUR-INSQ1-01-19" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-19" },
    { color: "PINK", upc: "TUR-INSQ1-10-19" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-19" },
    { color: "RED", upc: "TUR-INSQ1-09-19" },
    { color: "WHITE", upc: "TUR-INSQ1-03-19" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-01" },
    { color: "BLUE", upc: "TUR-INSQ1-08-01" },
    { color: "GREEN", upc: "TUR-INSQ1-04-01" },
    { color: "ICE", upc: "TUR-INSQ1-01-01" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-01" },
    { color: "PINK", upc: "TUR-INSQ1-10-01" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-01" },
    { color: "RED", upc: "TUR-INSQ1-09-01" },
    { color: "WHITE", upc: "TUR-INSQ1-03-01" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-02" },
    { color: "BLUE", upc: "TUR-INSQ1-08-02" },
    { color: "GREEN", upc: "TUR-INSQ1-04-02" },
    { color: "ICE", upc: "TUR-INSQ1-01-02" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-02" },
    { color: "PINK", upc: "TUR-INSQ1-10-02" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-02" },
    { color: "RED", upc: "TUR-INSQ1-09-02" },
    { color: "WHITE", upc: "TUR-INSQ1-03-02" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-03" },
    { color: "BLUE", upc: "TUR-INSQ1-08-03" },
    { color: "GREEN", upc: "TUR-INSQ1-04-03" },
    { color: "ICE", upc: "TUR-INSQ1-01-03" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-03" },
    { color: "PINK", upc: "TUR-INSQ1-10-03" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-03" },
    { color: "RED", upc: "TUR-INSQ1-09-03" },
    { color: "WHITE", upc: "TUR-INSQ1-03-03" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-04" },
    { color: "BLUE", upc: "TUR-INSQ1-08-04" },
    { color: "GREEN", upc: "TUR-INSQ1-04-04" },
    { color: "ICE", upc: "TUR-INSQ1-01-04" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-04" },
    { color: "PINK", upc: "TUR-INSQ1-10-04" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-04" },
    { color: "RED", upc: "TUR-INSQ1-09-04" },
    { color: "WHITE", upc: "TUR-INSQ1-03-04" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-05" },
    { color: "BLUE", upc: "TUR-INSQ1-08-05" },
    { color: "GREEN", upc: "TUR-INSQ1-04-05" },
    { color: "ICE", upc: "TUR-INSQ1-01-05" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-05" },
    { color: "PINK", upc: "TUR-INSQ1-10-05" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-05" },
    { color: "RED", upc: "TUR-INSQ1-09-05" },
    { color: "WHITE", upc: "TUR-INSQ1-03-05" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-06" },
    { color: "BLUE", upc: "TUR-INSQ1-08-06" },
    { color: "GREEN", upc: "TUR-INSQ1-04-06" },
    { color: "ICE", upc: "TUR-INSQ1-01-06" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-06" },
    { color: "PINK", upc: "TUR-INSQ1-10-06" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-06" },
    { color: "RED", upc: "TUR-INSQ1-09-06" },
    { color: "WHITE", upc: "TUR-INSQ1-03-06" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-07" },
    { color: "BLUE", upc: "TUR-INSQ1-08-07" },
    { color: "GREEN", upc: "TUR-INSQ1-04-07" },
    { color: "ICE", upc: "TUR-INSQ1-01-07" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-07" },
    { color: "PINK", upc: "TUR-INSQ1-10-07" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-07" },
    { color: "RED", upc: "TUR-INSQ1-09-07" },
    { color: "WHITE", upc: "TUR-INSQ1-03-07" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-08" },
    { color: "BLUE", upc: "TUR-INSQ1-08-08" },
    { color: "GREEN", upc: "TUR-INSQ1-04-08" },
    { color: "ICE", upc: "TUR-INSQ1-01-08" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-08" },
    { color: "PINK", upc: "TUR-INSQ1-10-08" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-08" },
    { color: "RED", upc: "TUR-INSQ1-09-08" },
    { color: "WHITE", upc: "TUR-INSQ1-03-08" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-09" },
    { color: "BLUE", upc: "TUR-INSQ1-08-09" },
    { color: "GREEN", upc: "TUR-INSQ1-04-09" },
    { color: "ICE", upc: "TUR-INSQ1-01-09" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-09" },
    { color: "PINK", upc: "TUR-INSQ1-10-09" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-09" },
    { color: "RED", upc: "TUR-INSQ1-09-09" },
    { color: "WHITE", upc: "TUR-INSQ1-03-09" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-10" },
    { color: "BLUE", upc: "TUR-INSQ1-08-10" },
    { color: "GREEN", upc: "TUR-INSQ1-04-10" },
    { color: "ICE", upc: "TUR-INSQ1-01-10" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-10" },
    { color: "PINK", upc: "TUR-INSQ1-10-10" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-10" },
    { color: "RED", upc: "TUR-INSQ1-09-10" },
    { color: "WHITE", upc: "TUR-INSQ1-03-10" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-11" },
    { color: "BLUE", upc: "TUR-INSQ1-08-11" },
    { color: "GREEN", upc: "TUR-INSQ1-04-11" },
    { color: "ICE", upc: "TUR-INSQ1-01-11" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-11" },
    { color: "PINK", upc: "TUR-INSQ1-10-11" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-11" },
    { color: "RED", upc: "TUR-INSQ1-09-11" },
    { color: "WHITE", upc: "TUR-INSQ1-03-11" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-12" },
    { color: "BLUE", upc: "TUR-INSQ1-08-12" },
    { color: "GREEN", upc: "TUR-INSQ1-04-12" },
    { color: "ICE", upc: "TUR-INSQ1-01-12" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-12" },
    { color: "PINK", upc: "TUR-INSQ1-10-12" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-12" },
    { color: "RED", upc: "TUR-INSQ1-09-12" },
    { color: "WHITE", upc: "TUR-INSQ1-03-12" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-13" },
    { color: "BLUE", upc: "TUR-INSQ1-08-13" },
    { color: "GREEN", upc: "TUR-INSQ1-04-13" },
    { color: "ICE", upc: "TUR-INSQ1-01-13" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-13" },
    { color: "PINK", upc: "TUR-INSQ1-10-13" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-13" },
    { color: "RED", upc: "TUR-INSQ1-09-13" },
    { color: "WHITE", upc: "TUR-INSQ1-03-13" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-14" },
    { color: "BLUE", upc: "TUR-INSQ1-08-14" },
    { color: "GREEN", upc: "TUR-INSQ1-04-14" },
    { color: "ICE", upc: "TUR-INSQ1-01-14" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-14" },
    { color: "PINK", upc: "TUR-INSQ1-10-14" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-14" },
    { color: "RED", upc: "TUR-INSQ1-09-14" },
    { color: "WHITE", upc: "TUR-INSQ1-03-14" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-15" },
    { color: "BLUE", upc: "TUR-INSQ1-08-15" },
    { color: "GREEN", upc: "TUR-INSQ1-04-15" },
    { color: "ICE", upc: "TUR-INSQ1-01-15" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-15" },
    { color: "PINK", upc: "TUR-INSQ1-10-15" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-15" },
    { color: "RED", upc: "TUR-INSQ1-09-15" },
    { color: "WHITE", upc: "TUR-INSQ1-03-15" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-16" },
    { color: "BLUE", upc: "TUR-INSQ1-08-16" },
    { color: "GREEN", upc: "TUR-INSQ1-04-16" },
    { color: "ICE", upc: "TUR-INSQ1-01-16" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-16" },
    { color: "PINK", upc: "TUR-INSQ1-10-16" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-16" },
    { color: "RED", upc: "TUR-INSQ1-09-16" },
    { color: "WHITE", upc: "TUR-INSQ1-03-16" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-17" },
    { color: "BLUE", upc: "TUR-INSQ1-08-17" },
    { color: "GREEN", upc: "TUR-INSQ1-04-17" },
    { color: "ICE", upc: "TUR-INSQ1-01-17" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-17" },
    { color: "PINK", upc: "TUR-INSQ1-10-17" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-17" },
    { color: "RED", upc: "TUR-INSQ1-09-17" },
    { color: "WHITE", upc: "TUR-INSQ1-03-17" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-18" },
    { color: "BLUE", upc: "TUR-INSQ1-08-18" },
    { color: "GREEN", upc: "TUR-INSQ1-04-18" },
    { color: "ICE", upc: "TUR-INSQ1-01-18" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-18" },
    { color: "PINK", upc: "TUR-INSQ1-10-18" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-18" },
    { color: "RED", upc: "TUR-INSQ1-09-18" },
    { color: "WHITE", upc: "TUR-INSQ1-03-18" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-19" },
    { color: "BLUE", upc: "TUR-INSQ1-08-19" },
    { color: "GREEN", upc: "TUR-INSQ1-04-19" },
    { color: "ICE", upc: "TUR-INSQ1-01-19" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-19" },
    { color: "PINK", upc: "TUR-INSQ1-10-19" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-19" },
    { color: "RED", upc: "TUR-INSQ1-09-19" },
    { color: "WHITE", upc: "TUR-INSQ1-03-19" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-01" },
    { color: "BLUE", upc: "TUR-INSQ1-08-01" },
    { color: "GREEN", upc: "TUR-INSQ1-04-01" },
    { color: "ICE", upc: "TUR-INSQ1-01-01" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-01" },
    { color: "PINK", upc: "TUR-INSQ1-10-01" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-01" },
    { color: "RED", upc: "TUR-INSQ1-09-01" },
    { color: "WHITE", upc: "TUR-INSQ1-03-01" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-02" },
    { color: "BLUE", upc: "TUR-INSQ1-08-02" },
    { color: "GREEN", upc: "TUR-INSQ1-04-02" },
    { color: "ICE", upc: "TUR-INSQ1-01-02" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-02" },
    { color: "PINK", upc: "TUR-INSQ1-10-02" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-02" },
    { color: "RED", upc: "TUR-INSQ1-09-02" },
    { color: "WHITE", upc: "TUR-INSQ1-03-02" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-03" },
    { color: "BLUE", upc: "TUR-INSQ1-08-03" },
    { color: "GREEN", upc: "TUR-INSQ1-04-03" },
    { color: "ICE", upc: "TUR-INSQ1-01-03" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-03" },
    { color: "PINK", upc: "TUR-INSQ1-10-03" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-03" },
    { color: "RED", upc: "TUR-INSQ1-09-03" },
    { color: "WHITE", upc: "TUR-INSQ1-03-03" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-04" },
    { color: "BLUE", upc: "TUR-INSQ1-08-04" },
    { color: "GREEN", upc: "TUR-INSQ1-04-04" },
    { color: "ICE", upc: "TUR-INSQ1-01-04" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-04" },
    { color: "PINK", upc: "TUR-INSQ1-10-04" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-04" },
    { color: "RED", upc: "TUR-INSQ1-09-04" },
    { color: "WHITE", upc: "TUR-INSQ1-03-04" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-05" },
    { color: "BLUE", upc: "TUR-INSQ1-08-05" },
    { color: "GREEN", upc: "TUR-INSQ1-04-05" },
    { color: "ICE", upc: "TUR-INSQ1-01-05" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-05" },
    { color: "PINK", upc: "TUR-INSQ1-10-05" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-05" },
    { color: "RED", upc: "TUR-INSQ1-09-05" },
    { color: "WHITE", upc: "TUR-INSQ1-03-05" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-06" },
    { color: "BLUE", upc: "TUR-INSQ1-08-06" },
    { color: "GREEN", upc: "TUR-INSQ1-04-06" },
    { color: "ICE", upc: "TUR-INSQ1-01-06" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-06" },
    { color: "PINK", upc: "TUR-INSQ1-10-06" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-06" },
    { color: "RED", upc: "TUR-INSQ1-09-06" },
    { color: "WHITE", upc: "TUR-INSQ1-03-06" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-07" },
    { color: "BLUE", upc: "TUR-INSQ1-08-07" },
    { color: "GREEN", upc: "TUR-INSQ1-04-07" },
    { color: "ICE", upc: "TUR-INSQ1-01-07" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-07" },
    { color: "PINK", upc: "TUR-INSQ1-10-07" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-07" },
    { color: "RED", upc: "TUR-INSQ1-09-07" },
    { color: "WHITE", upc: "TUR-INSQ1-03-07" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-08" },
    { color: "BLUE", upc: "TUR-INSQ1-08-08" },
    { color: "GREEN", upc: "TUR-INSQ1-04-08" },
    { color: "ICE", upc: "TUR-INSQ1-01-08" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-08" },
    { color: "PINK", upc: "TUR-INSQ1-10-08" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-08" },
    { color: "RED", upc: "TUR-INSQ1-09-08" },
    { color: "WHITE", upc: "TUR-INSQ1-03-08" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-09" },
    { color: "BLUE", upc: "TUR-INSQ1-08-09" },
    { color: "GREEN", upc: "TUR-INSQ1-04-09" },
    { color: "ICE", upc: "TUR-INSQ1-01-09" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-09" },
    { color: "PINK", upc: "TUR-INSQ1-10-09" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-09" },
    { color: "RED", upc: "TUR-INSQ1-09-09" },
    { color: "WHITE", upc: "TUR-INSQ1-03-09" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-10" },
    { color: "BLUE", upc: "TUR-INSQ1-08-10" },
    { color: "GREEN", upc: "TUR-INSQ1-04-10" },
    { color: "ICE", upc: "TUR-INSQ1-01-10" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-10" },
    { color: "PINK", upc: "TUR-INSQ1-10-10" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-10" },
    { color: "RED", upc: "TUR-INSQ1-09-10" },
    { color: "WHITE", upc: "TUR-INSQ1-03-10" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-11" },
    { color: "BLUE", upc: "TUR-INSQ1-08-11" },
    { color: "GREEN", upc: "TUR-INSQ1-04-11" },
    { color: "ICE", upc: "TUR-INSQ1-01-11" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-11" },
    { color: "PINK", upc: "TUR-INSQ1-10-11" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-11" },
    { color: "RED", upc: "TUR-INSQ1-09-11" },
    { color: "WHITE", upc: "TUR-INSQ1-03-11" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-12" },
    { color: "BLUE", upc: "TUR-INSQ1-08-12" },
    { color: "GREEN", upc: "TUR-INSQ1-04-12" },
    { color: "ICE", upc: "TUR-INSQ1-01-12" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-12" },
    { color: "PINK", upc: "TUR-INSQ1-10-12" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-12" },
    { color: "RED", upc: "TUR-INSQ1-09-12" },
    { color: "WHITE", upc: "TUR-INSQ1-03-12" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-13" },
    { color: "BLUE", upc: "TUR-INSQ1-08-13" },
    { color: "GREEN", upc: "TUR-INSQ1-04-13" },
    { color: "ICE", upc: "TUR-INSQ1-01-13" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-13" },
    { color: "PINK", upc: "TUR-INSQ1-10-13" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-13" },
    { color: "RED", upc: "TUR-INSQ1-09-13" },
    { color: "WHITE", upc: "TUR-INSQ1-03-13" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-14" },
    { color: "BLUE", upc: "TUR-INSQ1-08-14" },
    { color: "GREEN", upc: "TUR-INSQ1-04-14" },
    { color: "ICE", upc: "TUR-INSQ1-01-14" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-14" },
    { color: "PINK", upc: "TUR-INSQ1-10-14" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-14" },
    { color: "RED", upc: "TUR-INSQ1-09-14" },
    { color: "WHITE", upc: "TUR-INSQ1-03-14" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-15" },
    { color: "BLUE", upc: "TUR-INSQ1-08-15" },
    { color: "GREEN", upc: "TUR-INSQ1-04-15" },
    { color: "ICE", upc: "TUR-INSQ1-01-15" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-15" },
    { color: "PINK", upc: "TUR-INSQ1-10-15" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-15" },
    { color: "RED", upc: "TUR-INSQ1-09-15" },
    { color: "WHITE", upc: "TUR-INSQ1-03-15" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-16" },
    { color: "BLUE", upc: "TUR-INSQ1-08-16" },
    { color: "GREEN", upc: "TUR-INSQ1-04-16" },
    { color: "ICE", upc: "TUR-INSQ1-01-16" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-16" },
    { color: "PINK", upc: "TUR-INSQ1-10-16" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-16" },
    { color: "RED", upc: "TUR-INSQ1-09-16" },
    { color: "WHITE", upc: "TUR-INSQ1-03-16" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-17" },
    { color: "BLUE", upc: "TUR-INSQ1-08-17" },
    { color: "GREEN", upc: "TUR-INSQ1-04-17" },
    { color: "ICE", upc: "TUR-INSQ1-01-17" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-17" },
    { color: "PINK", upc: "TUR-INSQ1-10-17" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-17" },
    { color: "RED", upc: "TUR-INSQ1-09-17" },
    { color: "WHITE", upc: "TUR-INSQ1-03-17" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-18" },
    { color: "BLUE", upc: "TUR-INSQ1-08-18" },
    { color: "GREEN", upc: "TUR-INSQ1-04-18" },
    { color: "ICE", upc: "TUR-INSQ1-01-18" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-18" },
    { color: "PINK", upc: "TUR-INSQ1-10-18" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-18" },
    { color: "RED", upc: "TUR-INSQ1-09-18" },
    { color: "WHITE", upc: "TUR-INSQ1-03-18" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ1-02-19" },
    { color: "BLUE", upc: "TUR-INSQ1-08-19" },
    { color: "GREEN", upc: "TUR-INSQ1-04-19" },
    { color: "ICE", upc: "TUR-INSQ1-01-19" },
    { color: "ORANGE", upc: "TUR-INSQ1-06-19" },
    { color: "PINK", upc: "TUR-INSQ1-10-19" },
    { color: "PURPLE", upc: "TUR-INSQ1-07-19" },
    { color: "RED", upc: "TUR-INSQ1-09-19" },
    { color: "WHITE", upc: "TUR-INSQ1-03-19" },
    { color: "YELLOW", upc: "TUR-INSQ1-05-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-01" },
    { color: "ICE", upc: "TUR-INSQ2-01-01" },
    { color: "WHITE", upc: "TUR-INSQ2-03-01" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-01.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-01.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-01.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-02" },
    { color: "ICE", upc: "TUR-INSQ2-01-02" },
    { color: "WHITE", upc: "TUR-INSQ2-03-02" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-02.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-02.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-02.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-03" },
    { color: "ICE", upc: "TUR-INSQ2-01-03" },
    { color: "WHITE", upc: "TUR-INSQ2-03-03" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-03.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-03.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-03.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-04" },
    { color: "ICE", upc: "TUR-INSQ2-01-04" },
    { color: "WHITE", upc: "TUR-INSQ2-03-04" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-04.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-04.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-04.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-05" },
    { color: "ICE", upc: "TUR-INSQ2-01-05" },
    { color: "WHITE", upc: "TUR-INSQ2-03-05" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-05.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-05.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-05.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-06" },
    { color: "ICE", upc: "TUR-INSQ2-01-06" },
    { color: "WHITE", upc: "TUR-INSQ2-03-06" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-06.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-06.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-06.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-07" },
    { color: "ICE", upc: "TUR-INSQ2-01-07" },
    { color: "WHITE", upc: "TUR-INSQ2-03-07" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-07.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-07.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-07.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-08" },
    { color: "ICE", upc: "TUR-INSQ2-01-08" },
    { color: "WHITE", upc: "TUR-INSQ2-03-08" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-08.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-08.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-08.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-09" },
    { color: "ICE", upc: "TUR-INSQ2-01-09" },
    { color: "WHITE", upc: "TUR-INSQ2-03-09" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-10" },
    { color: "ICE", upc: "TUR-INSQ2-01-10" },
    { color: "WHITE", upc: "TUR-INSQ2-03-10" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-11" },
    { color: "ICE", upc: "TUR-INSQ2-01-11" },
    { color: "WHITE", upc: "TUR-INSQ2-03-11" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-01" },
    { color: "ICE", upc: "TUR-INSQ2-01-01" },
    { color: "WHITE", upc: "TUR-INSQ2-03-01" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-01.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-01.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-01.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-02" },
    { color: "ICE", upc: "TUR-INSQ2-01-02" },
    { color: "WHITE", upc: "TUR-INSQ2-03-02" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-02.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-02.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-02.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-03" },
    { color: "ICE", upc: "TUR-INSQ2-01-03" },
    { color: "WHITE", upc: "TUR-INSQ2-03-03" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-03.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-03.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-03.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-04" },
    { color: "ICE", upc: "TUR-INSQ2-01-04" },
    { color: "WHITE", upc: "TUR-INSQ2-03-04" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-04.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-04.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-04.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-05" },
    { color: "ICE", upc: "TUR-INSQ2-01-05" },
    { color: "WHITE", upc: "TUR-INSQ2-03-05" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-05.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-05.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-05.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-06" },
    { color: "ICE", upc: "TUR-INSQ2-01-06" },
    { color: "WHITE", upc: "TUR-INSQ2-03-06" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-06.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-06.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-06.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-07" },
    { color: "ICE", upc: "TUR-INSQ2-01-07" },
    { color: "WHITE", upc: "TUR-INSQ2-03-07" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-07.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-07.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-07.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-08" },
    { color: "ICE", upc: "TUR-INSQ2-01-08" },
    { color: "WHITE", upc: "TUR-INSQ2-03-08" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-08.5" },
    { color: "ICE", upc: "TUR-INSQ2-01-08.5" },
    { color: "WHITE", upc: "TUR-INSQ2-03-08.5" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-09" },
    { color: "ICE", upc: "TUR-INSQ2-01-09" },
    { color: "WHITE", upc: "TUR-INSQ2-03-09" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-10" },
    { color: "ICE", upc: "TUR-INSQ2-01-10" },
    { color: "WHITE", upc: "TUR-INSQ2-03-10" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQ2-02-11" },
    { color: "ICE", upc: "TUR-INSQ2-01-11" },
    { color: "WHITE", upc: "TUR-INSQ2-03-11" },
    { color: "YELLOW", upc: "TUR-INSQ2-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-01" },
    { color: "BLUE", upc: "TUR-INSQC-09-01" },
    { color: "GREEN", upc: "TUR-INSQC-04-01" },
    { color: "ICE", upc: "TUR-INSQC-01-01" },
    { color: "ORANGE", upc: "TUR-INSQC-06-01" },
    { color: "PINK", upc: "TUR-INSQC-10-01" },
    { color: "PURPLE", upc: "TUR-INSQC-07-01" },
    { color: "RED", upc: "TUR-INSQC-08-01" },
    { color: "WHITE", upc: "TUR-INSQC-03-01" },
    { color: "YELLOW", upc: "TUR-INSQC-05-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-02" },
    { color: "BLUE", upc: "TUR-INSQC-09-02" },
    { color: "GREEN", upc: "TUR-INSQC-04-02" },
    { color: "ICE", upc: "TUR-INSQC-01-02" },
    { color: "ORANGE", upc: "TUR-INSQC-06-02" },
    { color: "PINK", upc: "TUR-INSQC-10-02" },
    { color: "PURPLE", upc: "TUR-INSQC-07-02" },
    { color: "RED", upc: "TUR-INSQC-08-02" },
    { color: "WHITE", upc: "TUR-INSQC-03-02" },
    { color: "YELLOW", upc: "TUR-INSQC-05-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-03" },
    { color: "BLUE", upc: "TUR-INSQC-09-03" },
    { color: "GREEN", upc: "TUR-INSQC-04-03" },
    { color: "ICE", upc: "TUR-INSQC-01-03" },
    { color: "ORANGE", upc: "TUR-INSQC-06-03" },
    { color: "PINK", upc: "TUR-INSQC-10-03" },
    { color: "PURPLE", upc: "TUR-INSQC-07-03" },
    { color: "RED", upc: "TUR-INSQC-08-03" },
    { color: "WHITE", upc: "TUR-INSQC-03-03" },
    { color: "YELLOW", upc: "TUR-INSQC-05-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-04" },
    { color: "BLUE", upc: "TUR-INSQC-09-04" },
    { color: "GREEN", upc: "TUR-INSQC-04-04" },
    { color: "ICE", upc: "TUR-INSQC-01-04" },
    { color: "ORANGE", upc: "TUR-INSQC-06-04" },
    { color: "PINK", upc: "TUR-INSQC-10-04" },
    { color: "PURPLE", upc: "TUR-INSQC-07-04" },
    { color: "RED", upc: "TUR-INSQC-08-04" },
    { color: "WHITE", upc: "TUR-INSQC-03-04" },
    { color: "YELLOW", upc: "TUR-INSQC-05-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-05" },
    { color: "BLUE", upc: "TUR-INSQC-09-05" },
    { color: "GREEN", upc: "TUR-INSQC-04-05" },
    { color: "ICE", upc: "TUR-INSQC-01-05" },
    { color: "ORANGE", upc: "TUR-INSQC-06-05" },
    { color: "PINK", upc: "TUR-INSQC-10-05" },
    { color: "PURPLE", upc: "TUR-INSQC-07-05" },
    { color: "RED", upc: "TUR-INSQC-08-05" },
    { color: "WHITE", upc: "TUR-INSQC-03-05" },
    { color: "YELLOW", upc: "TUR-INSQC-05-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-06" },
    { color: "BLUE", upc: "TUR-INSQC-09-06" },
    { color: "GREEN", upc: "TUR-INSQC-04-06" },
    { color: "ICE", upc: "TUR-INSQC-01-05.5" },
    { color: "ORANGE", upc: "TUR-INSQC-06-06" },
    { color: "PINK", upc: "TUR-INSQC-10-05.5" },
    { color: "PURPLE", upc: "TUR-INSQC-07-06" },
    { color: "RED", upc: "TUR-INSQC-08-06" },
    { color: "WHITE", upc: "TUR-INSQC-03-06" },
    { color: "YELLOW", upc: "TUR-INSQC-05-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-07" },
    { color: "BLUE", upc: "TUR-INSQC-09-07" },
    { color: "GREEN", upc: "TUR-INSQC-04-07" },
    { color: "ICE", upc: "TUR-INSQC-01-06" },
    { color: "ORANGE", upc: "TUR-INSQC-06-07" },
    { color: "PINK", upc: "TUR-INSQC-10-06" },
    { color: "PURPLE", upc: "TUR-INSQC-07-07" },
    { color: "RED", upc: "TUR-INSQC-08-07" },
    { color: "WHITE", upc: "TUR-INSQC-03-07" },
    { color: "YELLOW", upc: "TUR-INSQC-05-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-08" },
    { color: "BLUE", upc: "TUR-INSQC-09-08" },
    { color: "GREEN", upc: "TUR-INSQC-04-08" },
    { color: "ICE", upc: "TUR-INSQC-01-07" },
    { color: "ORANGE", upc: "TUR-INSQC-06-08" },
    { color: "PINK", upc: "TUR-INSQC-10-07" },
    { color: "PURPLE", upc: "TUR-INSQC-07-08" },
    { color: "RED", upc: "TUR-INSQC-08-08" },
    { color: "WHITE", upc: "TUR-INSQC-03-08" },
    { color: "YELLOW", upc: "TUR-INSQC-05-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-09" },
    { color: "BLUE", upc: "TUR-INSQC-09-09" },
    { color: "GREEN", upc: "TUR-INSQC-04-09" },
    { color: "ICE", upc: "TUR-INSQC-01-08" },
    { color: "ORANGE", upc: "TUR-INSQC-06-09" },
    { color: "PINK", upc: "TUR-INSQC-10-08" },
    { color: "PURPLE", upc: "TUR-INSQC-07-09" },
    { color: "RED", upc: "TUR-INSQC-08-09" },
    { color: "WHITE", upc: "TUR-INSQC-03-09" },
    { color: "YELLOW", upc: "TUR-INSQC-05-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-10" },
    { color: "BLUE", upc: "TUR-INSQC-09-10" },
    { color: "GREEN", upc: "TUR-INSQC-04-10" },
    { color: "ICE", upc: "TUR-INSQC-01-09" },
    { color: "ORANGE", upc: "TUR-INSQC-06-10" },
    { color: "PINK", upc: "TUR-INSQC-10-09" },
    { color: "PURPLE", upc: "TUR-INSQC-07-10" },
    { color: "RED", upc: "TUR-INSQC-08-10" },
    { color: "WHITE", upc: "TUR-INSQC-03-10" },
    { color: "YELLOW", upc: "TUR-INSQC-05-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-11" },
    { color: "BLUE", upc: "TUR-INSQC-09-11" },
    { color: "GREEN", upc: "TUR-INSQC-04-11" },
    { color: "ICE", upc: "TUR-INSQC-01-10" },
    { color: "ORANGE", upc: "TUR-INSQC-06-11" },
    { color: "PINK", upc: "TUR-INSQC-10-10" },
    { color: "PURPLE", upc: "TUR-INSQC-07-11" },
    { color: "RED", upc: "TUR-INSQC-08-11" },
    { color: "WHITE", upc: "TUR-INSQC-03-11" },
    { color: "YELLOW", upc: "TUR-INSQC-05-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-12" },
    { color: "BLUE", upc: "TUR-INSQC-09-12" },
    { color: "GREEN", upc: "TUR-INSQC-04-12" },
    { color: "ICE", upc: "TUR-INSQC-01-11" },
    { color: "ORANGE", upc: "TUR-INSQC-06-12" },
    { color: "PINK", upc: "TUR-INSQC-10-11" },
    { color: "PURPLE", upc: "TUR-INSQC-07-12" },
    { color: "RED", upc: "TUR-INSQC-08-12" },
    { color: "WHITE", upc: "TUR-INSQC-03-12" },
    { color: "YELLOW", upc: "TUR-INSQC-05-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-13" },
    { color: "BLUE", upc: "TUR-INSQC-09-13" },
    { color: "GREEN", upc: "TUR-INSQC-04-13" },
    { color: "ICE", upc: "TUR-INSQC-01-12" },
    { color: "ORANGE", upc: "TUR-INSQC-06-13" },
    { color: "PINK", upc: "TUR-INSQC-10-12" },
    { color: "PURPLE", upc: "TUR-INSQC-07-13" },
    { color: "RED", upc: "TUR-INSQC-08-13" },
    { color: "WHITE", upc: "TUR-INSQC-03-13" },
    { color: "YELLOW", upc: "TUR-INSQC-05-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-14" },
    { color: "BLUE", upc: "TUR-INSQC-09-14" },
    { color: "GREEN", upc: "TUR-INSQC-04-14" },
    { color: "ICE", upc: "TUR-INSQC-01-13" },
    { color: "ORANGE", upc: "TUR-INSQC-06-14" },
    { color: "PINK", upc: "TUR-INSQC-10-13" },
    { color: "PURPLE", upc: "TUR-INSQC-07-14" },
    { color: "RED", upc: "TUR-INSQC-08-14" },
    { color: "WHITE", upc: "TUR-INSQC-03-14" },
    { color: "YELLOW", upc: "TUR-INSQC-05-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-15" },
    { color: "BLUE", upc: "TUR-INSQC-09-15" },
    { color: "GREEN", upc: "TUR-INSQC-04-15" },
    { color: "ICE", upc: "TUR-INSQC-01-14" },
    { color: "ORANGE", upc: "TUR-INSQC-06-15" },
    { color: "PINK", upc: "TUR-INSQC-10-14" },
    { color: "PURPLE", upc: "TUR-INSQC-07-15" },
    { color: "RED", upc: "TUR-INSQC-08-15" },
    { color: "WHITE", upc: "TUR-INSQC-03-15" },
    { color: "YELLOW", upc: "TUR-INSQC-05-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-16" },
    { color: "BLUE", upc: "TUR-INSQC-09-16" },
    { color: "GREEN", upc: "TUR-INSQC-04-16" },
    { color: "ICE", upc: "TUR-INSQC-01-15" },
    { color: "ORANGE", upc: "TUR-INSQC-06-16" },
    { color: "PINK", upc: "TUR-INSQC-10-15" },
    { color: "PURPLE", upc: "TUR-INSQC-07-16" },
    { color: "RED", upc: "TUR-INSQC-08-16" },
    { color: "WHITE", upc: "TUR-INSQC-03-16" },
    { color: "YELLOW", upc: "TUR-INSQC-05-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-17" },
    { color: "BLUE", upc: "TUR-INSQC-09-17" },
    { color: "GREEN", upc: "TUR-INSQC-04-17" },
    { color: "ICE", upc: "TUR-INSQC-01-16" },
    { color: "ORANGE", upc: "TUR-INSQC-06-17" },
    { color: "PINK", upc: "TUR-INSQC-10-16" },
    { color: "PURPLE", upc: "TUR-INSQC-07-17" },
    { color: "RED", upc: "TUR-INSQC-08-17" },
    { color: "WHITE", upc: "TUR-INSQC-03-17" },
    { color: "YELLOW", upc: "TUR-INSQC-05-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-18" },
    { color: "BLUE", upc: "TUR-INSQC-09-18" },
    { color: "GREEN", upc: "TUR-INSQC-04-18" },
    { color: "ICE", upc: "TUR-INSQC-01-17" },
    { color: "ORANGE", upc: "TUR-INSQC-06-18" },
    { color: "PINK", upc: "TUR-INSQC-10-17" },
    { color: "PURPLE", upc: "TUR-INSQC-07-18" },
    { color: "RED", upc: "TUR-INSQC-08-18" },
    { color: "WHITE", upc: "TUR-INSQC-03-18" },
    { color: "YELLOW", upc: "TUR-INSQC-05-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-19" },
    { color: "BLUE", upc: "TUR-INSQC-09-19" },
    { color: "GREEN", upc: "TUR-INSQC-04-19" },
    { color: "ICE", upc: "TUR-INSQC-01-18" },
    { color: "ORANGE", upc: "TUR-INSQC-06-19" },
    { color: "PINK", upc: "TUR-INSQC-10-18" },
    { color: "PURPLE", upc: "TUR-INSQC-07-19" },
    { color: "RED", upc: "TUR-INSQC-08-19" },
    { color: "WHITE", upc: "TUR-INSQC-03-19" },
    { color: "YELLOW", upc: "TUR-INSQC-05-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-01" },
    { color: "BLUE", upc: "TUR-INSQC-09-01" },
    { color: "GREEN", upc: "TUR-INSQC-04-01" },
    { color: "ICE", upc: "TUR-INSQC-01-01" },
    { color: "ORANGE", upc: "TUR-INSQC-06-01" },
    { color: "PINK", upc: "TUR-INSQC-10-01" },
    { color: "PURPLE", upc: "TUR-INSQC-07-01" },
    { color: "RED", upc: "TUR-INSQC-08-01" },
    { color: "WHITE", upc: "TUR-INSQC-03-01" },
    { color: "YELLOW", upc: "TUR-INSQC-05-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-02" },
    { color: "BLUE", upc: "TUR-INSQC-09-02" },
    { color: "GREEN", upc: "TUR-INSQC-04-02" },
    { color: "ICE", upc: "TUR-INSQC-01-02" },
    { color: "ORANGE", upc: "TUR-INSQC-06-02" },
    { color: "PINK", upc: "TUR-INSQC-10-02" },
    { color: "PURPLE", upc: "TUR-INSQC-07-02" },
    { color: "RED", upc: "TUR-INSQC-08-02" },
    { color: "WHITE", upc: "TUR-INSQC-03-02" },
    { color: "YELLOW", upc: "TUR-INSQC-05-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-03" },
    { color: "BLUE", upc: "TUR-INSQC-09-03" },
    { color: "GREEN", upc: "TUR-INSQC-04-03" },
    { color: "ICE", upc: "TUR-INSQC-01-03" },
    { color: "ORANGE", upc: "TUR-INSQC-06-03" },
    { color: "PINK", upc: "TUR-INSQC-10-03" },
    { color: "PURPLE", upc: "TUR-INSQC-07-03" },
    { color: "RED", upc: "TUR-INSQC-08-03" },
    { color: "WHITE", upc: "TUR-INSQC-03-03" },
    { color: "YELLOW", upc: "TUR-INSQC-05-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-04" },
    { color: "BLUE", upc: "TUR-INSQC-09-04" },
    { color: "GREEN", upc: "TUR-INSQC-04-04" },
    { color: "ICE", upc: "TUR-INSQC-01-04" },
    { color: "ORANGE", upc: "TUR-INSQC-06-04" },
    { color: "PINK", upc: "TUR-INSQC-10-04" },
    { color: "PURPLE", upc: "TUR-INSQC-07-04" },
    { color: "RED", upc: "TUR-INSQC-08-04" },
    { color: "WHITE", upc: "TUR-INSQC-03-04" },
    { color: "YELLOW", upc: "TUR-INSQC-05-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-05" },
    { color: "BLUE", upc: "TUR-INSQC-09-05" },
    { color: "GREEN", upc: "TUR-INSQC-04-05" },
    { color: "ICE", upc: "TUR-INSQC-01-05" },
    { color: "ORANGE", upc: "TUR-INSQC-06-05" },
    { color: "PINK", upc: "TUR-INSQC-10-05" },
    { color: "PURPLE", upc: "TUR-INSQC-07-05" },
    { color: "RED", upc: "TUR-INSQC-08-05" },
    { color: "WHITE", upc: "TUR-INSQC-03-05" },
    { color: "YELLOW", upc: "TUR-INSQC-05-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-06" },
    { color: "BLUE", upc: "TUR-INSQC-09-06" },
    { color: "GREEN", upc: "TUR-INSQC-04-06" },
    { color: "ICE", upc: "TUR-INSQC-01-05.5" },
    { color: "ORANGE", upc: "TUR-INSQC-06-06" },
    { color: "PINK", upc: "TUR-INSQC-10-05.5" },
    { color: "PURPLE", upc: "TUR-INSQC-07-06" },
    { color: "RED", upc: "TUR-INSQC-08-06" },
    { color: "WHITE", upc: "TUR-INSQC-03-06" },
    { color: "YELLOW", upc: "TUR-INSQC-05-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-07" },
    { color: "BLUE", upc: "TUR-INSQC-09-07" },
    { color: "GREEN", upc: "TUR-INSQC-04-07" },
    { color: "ICE", upc: "TUR-INSQC-01-06" },
    { color: "ORANGE", upc: "TUR-INSQC-06-07" },
    { color: "PINK", upc: "TUR-INSQC-10-06" },
    { color: "PURPLE", upc: "TUR-INSQC-07-07" },
    { color: "RED", upc: "TUR-INSQC-08-07" },
    { color: "WHITE", upc: "TUR-INSQC-03-07" },
    { color: "YELLOW", upc: "TUR-INSQC-05-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-08" },
    { color: "BLUE", upc: "TUR-INSQC-09-08" },
    { color: "GREEN", upc: "TUR-INSQC-04-08" },
    { color: "ICE", upc: "TUR-INSQC-01-07" },
    { color: "ORANGE", upc: "TUR-INSQC-06-08" },
    { color: "PINK", upc: "TUR-INSQC-10-07" },
    { color: "PURPLE", upc: "TUR-INSQC-07-08" },
    { color: "RED", upc: "TUR-INSQC-08-08" },
    { color: "WHITE", upc: "TUR-INSQC-03-08" },
    { color: "YELLOW", upc: "TUR-INSQC-05-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-09" },
    { color: "BLUE", upc: "TUR-INSQC-09-09" },
    { color: "GREEN", upc: "TUR-INSQC-04-09" },
    { color: "ICE", upc: "TUR-INSQC-01-08" },
    { color: "ORANGE", upc: "TUR-INSQC-06-09" },
    { color: "PINK", upc: "TUR-INSQC-10-08" },
    { color: "PURPLE", upc: "TUR-INSQC-07-09" },
    { color: "RED", upc: "TUR-INSQC-08-09" },
    { color: "WHITE", upc: "TUR-INSQC-03-09" },
    { color: "YELLOW", upc: "TUR-INSQC-05-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-10" },
    { color: "BLUE", upc: "TUR-INSQC-09-10" },
    { color: "GREEN", upc: "TUR-INSQC-04-10" },
    { color: "ICE", upc: "TUR-INSQC-01-09" },
    { color: "ORANGE", upc: "TUR-INSQC-06-10" },
    { color: "PINK", upc: "TUR-INSQC-10-09" },
    { color: "PURPLE", upc: "TUR-INSQC-07-10" },
    { color: "RED", upc: "TUR-INSQC-08-10" },
    { color: "WHITE", upc: "TUR-INSQC-03-10" },
    { color: "YELLOW", upc: "TUR-INSQC-05-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-11" },
    { color: "BLUE", upc: "TUR-INSQC-09-11" },
    { color: "GREEN", upc: "TUR-INSQC-04-11" },
    { color: "ICE", upc: "TUR-INSQC-01-10" },
    { color: "ORANGE", upc: "TUR-INSQC-06-11" },
    { color: "PINK", upc: "TUR-INSQC-10-10" },
    { color: "PURPLE", upc: "TUR-INSQC-07-11" },
    { color: "RED", upc: "TUR-INSQC-08-11" },
    { color: "WHITE", upc: "TUR-INSQC-03-11" },
    { color: "YELLOW", upc: "TUR-INSQC-05-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-12" },
    { color: "BLUE", upc: "TUR-INSQC-09-12" },
    { color: "GREEN", upc: "TUR-INSQC-04-12" },
    { color: "ICE", upc: "TUR-INSQC-01-11" },
    { color: "ORANGE", upc: "TUR-INSQC-06-12" },
    { color: "PINK", upc: "TUR-INSQC-10-11" },
    { color: "PURPLE", upc: "TUR-INSQC-07-12" },
    { color: "RED", upc: "TUR-INSQC-08-12" },
    { color: "WHITE", upc: "TUR-INSQC-03-12" },
    { color: "YELLOW", upc: "TUR-INSQC-05-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-13" },
    { color: "BLUE", upc: "TUR-INSQC-09-13" },
    { color: "GREEN", upc: "TUR-INSQC-04-13" },
    { color: "ICE", upc: "TUR-INSQC-01-12" },
    { color: "ORANGE", upc: "TUR-INSQC-06-13" },
    { color: "PINK", upc: "TUR-INSQC-10-12" },
    { color: "PURPLE", upc: "TUR-INSQC-07-13" },
    { color: "RED", upc: "TUR-INSQC-08-13" },
    { color: "WHITE", upc: "TUR-INSQC-03-13" },
    { color: "YELLOW", upc: "TUR-INSQC-05-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-14" },
    { color: "BLUE", upc: "TUR-INSQC-09-14" },
    { color: "GREEN", upc: "TUR-INSQC-04-14" },
    { color: "ICE", upc: "TUR-INSQC-01-13" },
    { color: "ORANGE", upc: "TUR-INSQC-06-14" },
    { color: "PINK", upc: "TUR-INSQC-10-13" },
    { color: "PURPLE", upc: "TUR-INSQC-07-14" },
    { color: "RED", upc: "TUR-INSQC-08-14" },
    { color: "WHITE", upc: "TUR-INSQC-03-14" },
    { color: "YELLOW", upc: "TUR-INSQC-05-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-15" },
    { color: "BLUE", upc: "TUR-INSQC-09-15" },
    { color: "GREEN", upc: "TUR-INSQC-04-15" },
    { color: "ICE", upc: "TUR-INSQC-01-14" },
    { color: "ORANGE", upc: "TUR-INSQC-06-15" },
    { color: "PINK", upc: "TUR-INSQC-10-14" },
    { color: "PURPLE", upc: "TUR-INSQC-07-15" },
    { color: "RED", upc: "TUR-INSQC-08-15" },
    { color: "WHITE", upc: "TUR-INSQC-03-15" },
    { color: "YELLOW", upc: "TUR-INSQC-05-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-16" },
    { color: "BLUE", upc: "TUR-INSQC-09-16" },
    { color: "GREEN", upc: "TUR-INSQC-04-16" },
    { color: "ICE", upc: "TUR-INSQC-01-15" },
    { color: "ORANGE", upc: "TUR-INSQC-06-16" },
    { color: "PINK", upc: "TUR-INSQC-10-15" },
    { color: "PURPLE", upc: "TUR-INSQC-07-16" },
    { color: "RED", upc: "TUR-INSQC-08-16" },
    { color: "WHITE", upc: "TUR-INSQC-03-16" },
    { color: "YELLOW", upc: "TUR-INSQC-05-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-17" },
    { color: "BLUE", upc: "TUR-INSQC-09-17" },
    { color: "GREEN", upc: "TUR-INSQC-04-17" },
    { color: "ICE", upc: "TUR-INSQC-01-16" },
    { color: "ORANGE", upc: "TUR-INSQC-06-17" },
    { color: "PINK", upc: "TUR-INSQC-10-16" },
    { color: "PURPLE", upc: "TUR-INSQC-07-17" },
    { color: "RED", upc: "TUR-INSQC-08-17" },
    { color: "WHITE", upc: "TUR-INSQC-03-17" },
    { color: "YELLOW", upc: "TUR-INSQC-05-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-18" },
    { color: "BLUE", upc: "TUR-INSQC-09-18" },
    { color: "GREEN", upc: "TUR-INSQC-04-18" },
    { color: "ICE", upc: "TUR-INSQC-01-17" },
    { color: "ORANGE", upc: "TUR-INSQC-06-18" },
    { color: "PINK", upc: "TUR-INSQC-10-17" },
    { color: "PURPLE", upc: "TUR-INSQC-07-18" },
    { color: "RED", upc: "TUR-INSQC-08-18" },
    { color: "WHITE", upc: "TUR-INSQC-03-18" },
    { color: "YELLOW", upc: "TUR-INSQC-05-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQC-02-19" },
    { color: "BLUE", upc: "TUR-INSQC-09-19" },
    { color: "GREEN", upc: "TUR-INSQC-04-19" },
    { color: "ICE", upc: "TUR-INSQC-01-18" },
    { color: "ORANGE", upc: "TUR-INSQC-06-19" },
    { color: "PINK", upc: "TUR-INSQC-10-18" },
    { color: "PURPLE", upc: "TUR-INSQC-07-19" },
    { color: "RED", upc: "TUR-INSQC-08-19" },
    { color: "WHITE", upc: "TUR-INSQC-03-19" },
    { color: "YELLOW", upc: "TUR-INSQC-05-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-01" },
    { color: "BLUE", upc: "TUR-INSQCP-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-02" },
    { color: "BLUE", upc: "TUR-INSQCP-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-03" },
    { color: "BLUE", upc: "TUR-INSQCP-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-04" },
    { color: "BLUE", upc: "TUR-INSQCP-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-05" },
    { color: "BLUE", upc: "TUR-INSQCP-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-06" },
    { color: "BLUE", upc: "TUR-INSQCP-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-07" },
    { color: "BLUE", upc: "TUR-INSQCP-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-08" },
    { color: "BLUE", upc: "TUR-INSQCP-01-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-09" },
    { color: "BLUE", upc: "TUR-INSQCP-01-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-10" },
    { color: "BLUE", upc: "TUR-INSQCP-01-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-11" },
    { color: "BLUE", upc: "TUR-INSQCP-01-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-13" },
    { color: "BLUE", upc: "TUR-INSQCP-01-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-14" },
    { color: "BLUE", upc: "TUR-INSQCP-01-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-15" },
    { color: "BLUE", upc: "TUR-INSQCP-01-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-16" },
    { color: "BLUE", upc: "TUR-INSQCP-01-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-17" },
    { color: "BLUE", upc: "TUR-INSQCP-01-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-18" },
    { color: "BLUE", upc: "TUR-INSQCP-01-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-19" },
    { color: "BLUE", upc: "TUR-INSQCP-01-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-01" },
    { color: "BLUE", upc: "TUR-INSQCP-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-02" },
    { color: "BLUE", upc: "TUR-INSQCP-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-03" },
    { color: "BLUE", upc: "TUR-INSQCP-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-04" },
    { color: "BLUE", upc: "TUR-INSQCP-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-05" },
    { color: "BLUE", upc: "TUR-INSQCP-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-06" },
    { color: "BLUE", upc: "TUR-INSQCP-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-07" },
    { color: "BLUE", upc: "TUR-INSQCP-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-08" },
    { color: "BLUE", upc: "TUR-INSQCP-01-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-09" },
    { color: "BLUE", upc: "TUR-INSQCP-01-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-10" },
    { color: "BLUE", upc: "TUR-INSQCP-01-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-11" },
    { color: "BLUE", upc: "TUR-INSQCP-01-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-13" },
    { color: "BLUE", upc: "TUR-INSQCP-01-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-14" },
    { color: "BLUE", upc: "TUR-INSQCP-01-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-15" },
    { color: "BLUE", upc: "TUR-INSQCP-01-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-16" },
    { color: "BLUE", upc: "TUR-INSQCP-01-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-17" },
    { color: "BLUE", upc: "TUR-INSQCP-01-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-18" },
    { color: "BLUE", upc: "TUR-INSQCP-01-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSQCP-02-19" },
    { color: "BLUE", upc: "TUR-INSQCP-01-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-01" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-01" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-01" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-02" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-02" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-02" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-03" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-03" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-03" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-04" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-04" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-04" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-05" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-05" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-05" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-06" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-06" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-06" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-07" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-07" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-07" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-08" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-08" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-08" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-09" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-09" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-09" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-10" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-10" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-10" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-11" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-11" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-11" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-12" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-12" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-12" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-13" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-13" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-13" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-14" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-14" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-14" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-15" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-15" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-15" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-16" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-16" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-16" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-17" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-17" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-17" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-18" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-18" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-18" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-19" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-19" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-19" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-01" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-01" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-01" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-02" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-02" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-02" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-03" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-03" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-03" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-04" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-04" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-04" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-05" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-05" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-05" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-06" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-06" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-06" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-07" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-07" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-07" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-08" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-08" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-08" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-09" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-09" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-09" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-10" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-10" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-10" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-11" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-11" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-11" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-12" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-12" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-12" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-13" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-13" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-13" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-14" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-14" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-14" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-15" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-15" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-15" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-16" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-16" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-16" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-17" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-17" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-17" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-17" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-18" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-18" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-18" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-18" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSPOWSB-02-19" },
    { color: "ICE", upc: "TUR-INSPOWSB-01-19" },
    { color: "WHITE", upc: "TUR-INSPOWSB-03-19" },
    { color: "YELLOW", upc: "TUR-INSPOWSB-04-19" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "17/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-01" },
    { color: "ICE", upc: "TUR-INSMQ-01-01" },
    { color: "PINK", upc: "TUR-INSMQ-05-01" },
    { color: "WHITE", upc: "TUR-INSMQ-03-01" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "35/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-02" },
    { color: "ICE", upc: "TUR-INSMQ-01-02" },
    { color: "PINK", upc: "TUR-INSMQ-05-02" },
    { color: "WHITE", upc: "TUR-INSMQ-03-02" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "9/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-03" },
    { color: "ICE", upc: "TUR-INSMQ-01-03" },
    { color: "PINK", upc: "TUR-INSMQ-05-03" },
    { color: "WHITE", upc: "TUR-INSMQ-03-03" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "37/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-04" },
    { color: "ICE", upc: "TUR-INSMQ-01-04" },
    { color: "PINK", upc: "TUR-INSMQ-05-04" },
    { color: "WHITE", upc: "TUR-INSMQ-03-04" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-05" },
    { color: "ICE", upc: "TUR-INSMQ-01-05" },
    { color: "PINK", upc: "TUR-INSMQ-05-05" },
    { color: "WHITE", upc: "TUR-INSMQ-03-05" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-06" },
    { color: "ICE", upc: "TUR-INSMQ-01-06" },
    { color: "PINK", upc: "TUR-INSMQ-05-06" },
    { color: "WHITE", upc: "TUR-INSMQ-03-06" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-07" },
    { color: "ICE", upc: "TUR-INSMQ-01-07" },
    { color: "PINK", upc: "TUR-INSMQ-05-07" },
    { color: "WHITE", upc: "TUR-INSMQ-03-07" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-08" },
    { color: "ICE", upc: "TUR-INSMQ-01-08" },
    { color: "PINK", upc: "TUR-INSMQ-05-08" },
    { color: "WHITE", upc: "TUR-INSMQ-03-08" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-09" },
    { color: "ICE", upc: "TUR-INSMQ-01-09" },
    { color: "PINK", upc: "TUR-INSMQ-05-09" },
    { color: "WHITE", upc: "TUR-INSMQ-03-09" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-10" },
    { color: "ICE", upc: "TUR-INSMQ-01-10" },
    { color: "PINK", upc: "TUR-INSMQ-05-10" },
    { color: "WHITE", upc: "TUR-INSMQ-03-10" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-11" },
    { color: "ICE", upc: "TUR-INSMQ-01-11" },
    { color: "PINK", upc: "TUR-INSMQ-05-11" },
    { color: "WHITE", upc: "TUR-INSMQ-03-11" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-12" },
    { color: "ICE", upc: "TUR-INSMQ-01-12" },
    { color: "PINK", upc: "TUR-INSMQ-05-12" },
    { color: "WHITE", upc: "TUR-INSMQ-03-12" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-13" },
    { color: "ICE", upc: "TUR-INSMQ-01-13" },
    { color: "PINK", upc: "TUR-INSMQ-05-13" },
    { color: "WHITE", upc: "TUR-INSMQ-03-13" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-14" },
    { color: "ICE", upc: "TUR-INSMQ-01-14" },
    { color: "PINK", upc: "TUR-INSMQ-05-14" },
    { color: "WHITE", upc: "TUR-INSMQ-03-14" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-15" },
    { color: "ICE", upc: "TUR-INSMQ-01-15" },
    { color: "PINK", upc: "TUR-INSMQ-05-15" },
    { color: "WHITE", upc: "TUR-INSMQ-03-15" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "17/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-01" },
    { color: "ICE", upc: "TUR-INSMQ-01-01" },
    { color: "PINK", upc: "TUR-INSMQ-05-01" },
    { color: "WHITE", upc: "TUR-INSMQ-03-01" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "35/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-02" },
    { color: "ICE", upc: "TUR-INSMQ-01-02" },
    { color: "PINK", upc: "TUR-INSMQ-05-02" },
    { color: "WHITE", upc: "TUR-INSMQ-03-02" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "9/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-03" },
    { color: "ICE", upc: "TUR-INSMQ-01-03" },
    { color: "PINK", upc: "TUR-INSMQ-05-03" },
    { color: "WHITE", upc: "TUR-INSMQ-03-03" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "37/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-04" },
    { color: "ICE", upc: "TUR-INSMQ-01-04" },
    { color: "PINK", upc: "TUR-INSMQ-05-04" },
    { color: "WHITE", upc: "TUR-INSMQ-03-04" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-05" },
    { color: "ICE", upc: "TUR-INSMQ-01-05" },
    { color: "PINK", upc: "TUR-INSMQ-05-05" },
    { color: "WHITE", upc: "TUR-INSMQ-03-05" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-06" },
    { color: "ICE", upc: "TUR-INSMQ-01-06" },
    { color: "PINK", upc: "TUR-INSMQ-05-06" },
    { color: "WHITE", upc: "TUR-INSMQ-03-06" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-07" },
    { color: "ICE", upc: "TUR-INSMQ-01-07" },
    { color: "PINK", upc: "TUR-INSMQ-05-07" },
    { color: "WHITE", upc: "TUR-INSMQ-03-07" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-08" },
    { color: "ICE", upc: "TUR-INSMQ-01-08" },
    { color: "PINK", upc: "TUR-INSMQ-05-08" },
    { color: "WHITE", upc: "TUR-INSMQ-03-08" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-09" },
    { color: "ICE", upc: "TUR-INSMQ-01-09" },
    { color: "PINK", upc: "TUR-INSMQ-05-09" },
    { color: "WHITE", upc: "TUR-INSMQ-03-09" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-10" },
    { color: "ICE", upc: "TUR-INSMQ-01-10" },
    { color: "PINK", upc: "TUR-INSMQ-05-10" },
    { color: "WHITE", upc: "TUR-INSMQ-03-10" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-11" },
    { color: "ICE", upc: "TUR-INSMQ-01-11" },
    { color: "PINK", upc: "TUR-INSMQ-05-11" },
    { color: "WHITE", upc: "TUR-INSMQ-03-11" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-12" },
    { color: "ICE", upc: "TUR-INSMQ-01-12" },
    { color: "PINK", upc: "TUR-INSMQ-05-12" },
    { color: "WHITE", upc: "TUR-INSMQ-03-12" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-13" },
    { color: "ICE", upc: "TUR-INSMQ-01-13" },
    { color: "PINK", upc: "TUR-INSMQ-05-13" },
    { color: "WHITE", upc: "TUR-INSMQ-03-13" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-14" },
    { color: "ICE", upc: "TUR-INSMQ-01-14" },
    { color: "PINK", upc: "TUR-INSMQ-05-14" },
    { color: "WHITE", upc: "TUR-INSMQ-03-14" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "TUR-INSMQ-02-15" },
    { color: "ICE", upc: "TUR-INSMQ-01-15" },
    { color: "PINK", upc: "TUR-INSMQ-05-15" },
    { color: "WHITE", upc: "TUR-INSMQ-03-15" },
    { color: "YELLOW", upc: "TUR-INSMQ-04-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "9/16",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-00" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-00" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-00" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-00" },
    { color: "NEON", upc: "ULT-INSTLOR-08-00" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-00" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "37/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-00.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-00.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-00.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-00.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-00.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-00.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-00.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-00.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-01" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-01" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-01" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-01" },
    { color: "NEON", upc: "ULT-INSTLOR-08-01" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-01" },
    { color: "RED", upc: "ULT-INSTLOR-06-01" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-01.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-01.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-01.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-01.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-01.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-01.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-01.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-02" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-02" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-02" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-02" },
    { color: "NEON", upc: "ULT-INSTLOR-08-02" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-02" },
    { color: "RED", upc: "ULT-INSTLOR-06-02" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-02.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-02.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-02.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-02.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-02.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-02.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-02.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-03" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-03" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-03" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-03" },
    { color: "NEON", upc: "ULT-INSTLOR-08-03" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-03" },
    { color: "RED", upc: "ULT-INSTLOR-06-03" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-03.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-03.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-03.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-03.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-03.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-03.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-03.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-04" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-04" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-04" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-04" },
    { color: "NEON", upc: "ULT-INSTLOR-08-04" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-04" },
    { color: "RED", upc: "ULT-INSTLOR-06-04" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-04.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-04.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-04.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-04.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-04.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-04.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-04.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-05" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-05" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-05" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-05" },
    { color: "NEON", upc: "ULT-INSTLOR-08-05" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-05" },
    { color: "RED", upc: "ULT-INSTLOR-06-05" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-05.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-05.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-05.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-05.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-05.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-05.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-05.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-06" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-06" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-06" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-06" },
    { color: "NEON", upc: "ULT-INSTLOR-08-06" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-06" },
    { color: "RED", upc: "ULT-INSTLOR-06-06" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-06.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-06.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-06.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-06.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-06.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-06.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-06.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-07" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-07" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-07" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-07" },
    { color: "NEON", upc: "ULT-INSTLOR-08-07" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-07" },
    { color: "RED", upc: "ULT-INSTLOR-06-07" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-08.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-08.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-08.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-08.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-08.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-08.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-08.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-09" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-09" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-09" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-09" },
    { color: "NEON", upc: "ULT-INSTLOR-08-09" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-09" },
    { color: "RED", upc: "ULT-INSTLOR-06-09" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-09.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-09.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-09.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-09.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-09.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-09.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-09.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-09.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-10" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-10" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-10" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-10" },
    { color: "NEON", upc: "ULT-INSTLOR-08-10" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-10" },
    { color: "RED", upc: "ULT-INSTLOR-06-10" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "55/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-10.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-10.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-10.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-10.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-10.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-10.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-10.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-10.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-11" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-11" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-11" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-11" },
    { color: "NEON", upc: "ULT-INSTLOR-08-11" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-11" },
    { color: "RED", upc: "ULT-INSTLOR-06-11" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "57/64",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-9" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-9" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-9" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-9" },
    { color: "NEON", upc: "ULT-INSTLOR-08-9" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-9" },
    { color: "RED", upc: "ULT-INSTLOR-06-9" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-9" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOR-02-9.5" },
    { color: "BLUE", upc: "ULT-INSTLOR-03-9.5" },
    { color: "CLEAR", upc: "ULT-INSTLOR-01-9.5" },
    { color: "GREEN", upc: "ULT-INSTLOR-11-9.5" },
    { color: "NEON", upc: "ULT-INSTLOR-08-9.5" },
    { color: "ORANGE", upc: "ULT-INSTLOR-07-9.5" },
    { color: "RED", upc: "ULT-INSTLOR-06-9.5" },
    { color: "WHITE", upc: "ULT-INSTLOR-10-9.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "9/16",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "37/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-00.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "19/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "39/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "5/8",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "41/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "21/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "43/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "11/16",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "45/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "23/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "47/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "3/4",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "49/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "25/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "51/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "13/16",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "53/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "27/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "55/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-09.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "7/8",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "57/64",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-10.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "29/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLS-01-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "17/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02--01" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01--01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "9/16",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-00" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-01" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-02" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-03" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-04" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-05" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-06" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "ULT-INSTLOL-02-07" },
    { color: "CLEAR", upc: "ULT-INSTLOL-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "9/16",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "19/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "5/8",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "21/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "11/16",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "23/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "3/4",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "25/32",
  variants: [
    { color: "CLEAR", upc: "ULT-INSTLSJR-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "9/16",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-00" },
    { color: "BLUE", upc: "VIS-INSPO-07-00" },
    { color: "CLEAR", upc: "VIS-INSPO-04-00" },
    { color: "GREEN", upc: "VIS-INSPO-05-00" },
    { color: "ORANGE", upc: "VIS-INSPO-06-00" },
    { color: "PINK", upc: "VIS-INSPO-09-00" },
    { color: "PURPLE", upc: "VIS-INSPO-08-00" },
    { color: "RED", upc: "VIS-INSPO-10-00" },
    { color: "WHITE", upc: "VIS-INSPO-02-00" },
    { color: "YELLOW", upc: "VIS-INSPO-01-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "37/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-00.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-00.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-00.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-00.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-00.5" },
    { color: "PINK", upc: "VIS-INSPO-09-00.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-00.5" },
    { color: "RED", upc: "VIS-INSPO-10-00.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-00.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-00.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-01" },
    { color: "BLUE", upc: "VIS-INSPO-07-01" },
    { color: "CLEAR", upc: "VIS-INSPO-04-01" },
    { color: "GREEN", upc: "VIS-INSPO-05-01" },
    { color: "ORANGE", upc: "VIS-INSPO-06-01" },
    { color: "PINK", upc: "VIS-INSPO-09-01" },
    { color: "PURPLE", upc: "VIS-INSPO-08-01" },
    { color: "RED", upc: "VIS-INSPO-10-01" },
    { color: "WHITE", upc: "VIS-INSPO-02-01" },
    { color: "YELLOW", upc: "VIS-INSPO-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-01.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-01.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-01.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-01.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-01.5" },
    { color: "PINK", upc: "VIS-INSPO-09-01.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-01.5" },
    { color: "RED", upc: "VIS-INSPO-10-01.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-01.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-02" },
    { color: "BLUE", upc: "VIS-INSPO-07-02" },
    { color: "CLEAR", upc: "VIS-INSPO-04-02" },
    { color: "GREEN", upc: "VIS-INSPO-05-02" },
    { color: "ORANGE", upc: "VIS-INSPO-06-02" },
    { color: "PINK", upc: "VIS-INSPO-09-02" },
    { color: "PURPLE", upc: "VIS-INSPO-08-02" },
    { color: "RED", upc: "VIS-INSPO-10-02" },
    { color: "WHITE", upc: "VIS-INSPO-02-02" },
    { color: "YELLOW", upc: "VIS-INSPO-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-02.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-02.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-02.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-02.5" },
    { color: "NEON", upc: "VIS-INSPO-11-02.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-02.5" },
    { color: "PINK", upc: "VIS-INSPO-09-02.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-02.5" },
    { color: "RED", upc: "VIS-INSPO-10-02.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-02.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-03" },
    { color: "BLUE", upc: "VIS-INSPO-07-03" },
    { color: "CLEAR", upc: "VIS-INSPO-04-03" },
    { color: "GREEN", upc: "VIS-INSPO-05-03" },
    { color: "NEON", upc: "VIS-INSPO-11-03" },
    { color: "ORANGE", upc: "VIS-INSPO-06-03" },
    { color: "PINK", upc: "VIS-INSPO-09-03" },
    { color: "PURPLE", upc: "VIS-INSPO-08-03" },
    { color: "RED", upc: "VIS-INSPO-10-03" },
    { color: "WHITE", upc: "VIS-INSPO-02-03" },
    { color: "YELLOW", upc: "VIS-INSPO-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-03.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-03.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-03.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-03.5" },
    { color: "NEON", upc: "VIS-INSPO-11-03.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-03.5" },
    { color: "PINK", upc: "VIS-INSPO-09-03.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-03.5" },
    { color: "RED", upc: "VIS-INSPO-10-03.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-03.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-04" },
    { color: "BLUE", upc: "VIS-INSPO-07-04" },
    { color: "CLEAR", upc: "VIS-INSPO-04-04" },
    { color: "GREEN", upc: "VIS-INSPO-05-04" },
    { color: "NEON", upc: "VIS-INSPO-11-04" },
    { color: "ORANGE", upc: "VIS-INSPO-06-04" },
    { color: "PINK", upc: "VIS-INSPO-09-04" },
    { color: "PURPLE", upc: "VIS-INSPO-08-04" },
    { color: "RED", upc: "VIS-INSPO-10-04" },
    { color: "WHITE", upc: "VIS-INSPO-02-04" },
    { color: "YELLOW", upc: "VIS-INSPO-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-04.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-04.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-04.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-04.5" },
    { color: "NEON", upc: "VIS-INSPO-11-04.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-04.5" },
    { color: "PINK", upc: "VIS-INSPO-09-04.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-04.5" },
    { color: "RED", upc: "VIS-INSPO-10-04.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-04.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-05" },
    { color: "BLUE", upc: "VIS-INSPO-07-05" },
    { color: "CLEAR", upc: "VIS-INSPO-04-05" },
    { color: "GREEN", upc: "VIS-INSPO-05-05" },
    { color: "NEON", upc: "VIS-INSPO-11-05" },
    { color: "ORANGE", upc: "VIS-INSPO-06-05" },
    { color: "PINK", upc: "VIS-INSPO-09-05" },
    { color: "PURPLE", upc: "VIS-INSPO-08-05" },
    { color: "RED", upc: "VIS-INSPO-10-05" },
    { color: "WHITE", upc: "VIS-INSPO-02-05" },
    { color: "YELLOW", upc: "VIS-INSPO-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-05.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-05.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-05.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-05.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-05.5" },
    { color: "PINK", upc: "VIS-INSPO-09-05.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-05.5" },
    { color: "RED", upc: "VIS-INSPO-10-05.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-05.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-06" },
    { color: "BLUE", upc: "VIS-INSPO-07-06" },
    { color: "CLEAR", upc: "VIS-INSPO-04-06" },
    { color: "GREEN", upc: "VIS-INSPO-05-06" },
    { color: "ORANGE", upc: "VIS-INSPO-06-06" },
    { color: "PINK", upc: "VIS-INSPO-09-06" },
    { color: "PURPLE", upc: "VIS-INSPO-08-06" },
    { color: "RED", upc: "VIS-INSPO-10-06" },
    { color: "WHITE", upc: "VIS-INSPO-02-06" },
    { color: "YELLOW", upc: "VIS-INSPO-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-06.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-06.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-06.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-06.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-06.5" },
    { color: "PINK", upc: "VIS-INSPO-09-06.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-06.5" },
    { color: "RED", upc: "VIS-INSPO-10-06.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-06.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-07" },
    { color: "BLUE", upc: "VIS-INSPO-07-07" },
    { color: "CLEAR", upc: "VIS-INSPO-04-07" },
    { color: "GREEN", upc: "VIS-INSPO-05-07" },
    { color: "ORANGE", upc: "VIS-INSPO-06-07" },
    { color: "PINK", upc: "VIS-INSPO-09-07" },
    { color: "PURPLE", upc: "VIS-INSPO-08-07" },
    { color: "RED", upc: "VIS-INSPO-10-07" },
    { color: "WHITE", upc: "VIS-INSPO-02-07" },
    { color: "YELLOW", upc: "VIS-INSPO-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-07.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-07.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-07.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-07.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-07.5" },
    { color: "PINK", upc: "VIS-INSPO-09-07.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-07.5" },
    { color: "RED", upc: "VIS-INSPO-10-07.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-07.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-08" },
    { color: "BLUE", upc: "VIS-INSPO-07-08" },
    { color: "CLEAR", upc: "VIS-INSPO-04-08" },
    { color: "GREEN", upc: "VIS-INSPO-05-08" },
    { color: "ORANGE", upc: "VIS-INSPO-06-08" },
    { color: "PINK", upc: "VIS-INSPO-09-08" },
    { color: "PURPLE", upc: "VIS-INSPO-08-08" },
    { color: "RED", upc: "VIS-INSPO-10-08" },
    { color: "WHITE", upc: "VIS-INSPO-02-08" },
    { color: "YELLOW", upc: "VIS-INSPO-01-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-08.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-08.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-08.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-08.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-08.5" },
    { color: "PINK", upc: "VIS-INSPO-09-08.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-08.5" },
    { color: "RED", upc: "VIS-INSPO-10-08.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-08.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-09" },
    { color: "BLUE", upc: "VIS-INSPO-07-09" },
    { color: "CLEAR", upc: "VIS-INSPO-04-09" },
    { color: "GREEN", upc: "VIS-INSPO-05-09" },
    { color: "ORANGE", upc: "VIS-INSPO-06-09" },
    { color: "PINK", upc: "VIS-INSPO-09-09" },
    { color: "PURPLE", upc: "VIS-INSPO-08-09" },
    { color: "RED", upc: "VIS-INSPO-10-09" },
    { color: "WHITE", upc: "VIS-INSPO-02-09" },
    { color: "YELLOW", upc: "VIS-INSPO-01-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "55/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-09.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-09.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-09.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-09.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-09.5" },
    { color: "PINK", upc: "VIS-INSPO-09-09.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-09.5" },
    { color: "RED", upc: "VIS-INSPO-10-09.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-09.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-09.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-10" },
    { color: "BLUE", upc: "VIS-INSPO-07-10" },
    { color: "CLEAR", upc: "VIS-INSPO-04-10" },
    { color: "GREEN", upc: "VIS-INSPO-05-10" },
    { color: "ORANGE", upc: "VIS-INSPO-06-10" },
    { color: "PINK", upc: "VIS-INSPO-09-10" },
    { color: "PURPLE", upc: "VIS-INSPO-08-10" },
    { color: "RED", upc: "VIS-INSPO-10-10" },
    { color: "WHITE", upc: "VIS-INSPO-02-10" },
    { color: "YELLOW", upc: "VIS-INSPO-01-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "57/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-10.5" },
    { color: "BLUE", upc: "VIS-INSPO-07-10.5" },
    { color: "CLEAR", upc: "VIS-INSPO-04-10.5" },
    { color: "GREEN", upc: "VIS-INSPO-05-10.5" },
    { color: "ORANGE", upc: "VIS-INSPO-06-10.5" },
    { color: "PINK", upc: "VIS-INSPO-09-10.5" },
    { color: "PURPLE", upc: "VIS-INSPO-08-10.5" },
    { color: "RED", upc: "VIS-INSPO-10-10.5" },
    { color: "WHITE", upc: "VIS-INSPO-02-10.5" },
    { color: "YELLOW", upc: "VIS-INSPO-01-10.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPO-03-11" },
    { color: "BLUE", upc: "VIS-INSPO-07-11" },
    { color: "CLEAR", upc: "VIS-INSPO-04-11" },
    { color: "GREEN", upc: "VIS-INSPO-05-11" },
    { color: "ORANGE", upc: "VIS-INSPO-06-11" },
    { color: "PINK", upc: "VIS-INSPO-09-11" },
    { color: "PURPLE", upc: "VIS-INSPO-08-11" },
    { color: "RED", upc: "VIS-INSPO-10-11" },
    { color: "WHITE", upc: "VIS-INSPO-02-11" },
    { color: "YELLOW", upc: "VIS-INSPO-01-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "9/16",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-00" },
    { color: "BLUE", upc: "VIS-INSPS-07-00" },
    { color: "CLEAR", upc: "VIS-INSPS-04-00" },
    { color: "GREEN", upc: "VIS-INSPS-05-00" },
    { color: "ORANGE", upc: "VIS-INSPS-06-00" },
    { color: "PINK", upc: "VIS-INSPS-09-00" },
    { color: "PURPLE", upc: "VIS-INSPS-08-00" },
    { color: "RED", upc: "VIS-INSPS-10-00" },
    { color: "WHITE", upc: "VIS-INSPS-02-00" },
    { color: "YELLOW", upc: "VIS-INSPS-01-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "37/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-00.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-00.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-00.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-00.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-00.5" },
    { color: "PINK", upc: "VIS-INSPS-09-00.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-00.5" },
    { color: "RED", upc: "VIS-INSPS-10-00.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-00.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-00.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-01" },
    { color: "BLUE", upc: "VIS-INSPS-07-01" },
    { color: "CLEAR", upc: "VIS-INSPS-04-01" },
    { color: "GREEN", upc: "VIS-INSPS-05-01" },
    { color: "ORANGE", upc: "VIS-INSPS-06-01" },
    { color: "PINK", upc: "VIS-INSPS-09-01" },
    { color: "PURPLE", upc: "VIS-INSPS-08-01" },
    { color: "RED", upc: "VIS-INSPS-10-01" },
    { color: "WHITE", upc: "VIS-INSPS-02-01" },
    { color: "YELLOW", upc: "VIS-INSPS-01-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-01.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-01.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-01.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-01.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-01.5" },
    { color: "PINK", upc: "VIS-INSPS-09-01.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-01.5" },
    { color: "RED", upc: "VIS-INSPS-10-01.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-01.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-02" },
    { color: "BLUE", upc: "VIS-INSPS-07-02" },
    { color: "CLEAR", upc: "VIS-INSPS-04-02" },
    { color: "GREEN", upc: "VIS-INSPS-05-02" },
    { color: "ORANGE", upc: "VIS-INSPS-06-02" },
    { color: "PINK", upc: "VIS-INSPS-09-02" },
    { color: "PURPLE", upc: "VIS-INSPS-08-02" },
    { color: "RED", upc: "VIS-INSPS-10-02" },
    { color: "WHITE", upc: "VIS-INSPS-02-02" },
    { color: "YELLOW", upc: "VIS-INSPS-01-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-02.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-02.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-02.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-02.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-02.5" },
    { color: "PINK", upc: "VIS-INSPS-09-02.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-02.5" },
    { color: "RED", upc: "VIS-INSPS-10-02.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-02.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-03" },
    { color: "BLUE", upc: "VIS-INSPS-07-03" },
    { color: "CLEAR", upc: "VIS-INSPS-04-03" },
    { color: "GREEN", upc: "VIS-INSPS-05-03" },
    { color: "ORANGE", upc: "VIS-INSPS-06-03" },
    { color: "PINK", upc: "VIS-INSPS-09-03" },
    { color: "PURPLE", upc: "VIS-INSPS-08-03" },
    { color: "RED", upc: "VIS-INSPS-10-03" },
    { color: "WHITE", upc: "VIS-INSPS-02-03" },
    { color: "YELLOW", upc: "VIS-INSPS-01-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-03.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-03.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-03.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-03.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-03.5" },
    { color: "PINK", upc: "VIS-INSPS-09-03.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-03.5" },
    { color: "RED", upc: "VIS-INSPS-10-03.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-03.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-04" },
    { color: "BLUE", upc: "VIS-INSPS-07-04" },
    { color: "CLEAR", upc: "VIS-INSPS-04-04" },
    { color: "GREEN", upc: "VIS-INSPS-05-04" },
    { color: "ORANGE", upc: "VIS-INSPS-06-04" },
    { color: "PINK", upc: "VIS-INSPS-09-04" },
    { color: "PURPLE", upc: "VIS-INSPS-08-04" },
    { color: "RED", upc: "VIS-INSPS-10-04" },
    { color: "WHITE", upc: "VIS-INSPS-02-04" },
    { color: "YELLOW", upc: "VIS-INSPS-01-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-04.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-04.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-04.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-04.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-04.5" },
    { color: "PINK", upc: "VIS-INSPS-09-04.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-04.5" },
    { color: "RED", upc: "VIS-INSPS-10-04.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-04.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-05" },
    { color: "BLUE", upc: "VIS-INSPS-07-05" },
    { color: "CLEAR", upc: "VIS-INSPS-04-05" },
    { color: "GREEN", upc: "VIS-INSPS-05-05" },
    { color: "ORANGE", upc: "VIS-INSPS-06-05" },
    { color: "PINK", upc: "VIS-INSPS-09-05" },
    { color: "PURPLE", upc: "VIS-INSPS-08-05" },
    { color: "RED", upc: "VIS-INSPS-10-05" },
    { color: "WHITE", upc: "VIS-INSPS-02-05" },
    { color: "YELLOW", upc: "VIS-INSPS-01-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-05.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-05.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-05.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-05.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-05.5" },
    { color: "PINK", upc: "VIS-INSPS-09-05.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-05.5" },
    { color: "RED", upc: "VIS-INSPS-10-05.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-05.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-06" },
    { color: "BLUE", upc: "VIS-INSPS-07-06" },
    { color: "CLEAR", upc: "VIS-INSPS-04-06" },
    { color: "GREEN", upc: "VIS-INSPS-05-06" },
    { color: "ORANGE", upc: "VIS-INSPS-06-06" },
    { color: "PINK", upc: "VIS-INSPS-09-06" },
    { color: "PURPLE", upc: "VIS-INSPS-08-06" },
    { color: "RED", upc: "VIS-INSPS-10-06" },
    { color: "WHITE", upc: "VIS-INSPS-02-06" },
    { color: "YELLOW", upc: "VIS-INSPS-01-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-06.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-06.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-06.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-06.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-06.5" },
    { color: "PINK", upc: "VIS-INSPS-09-06.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-06.5" },
    { color: "RED", upc: "VIS-INSPS-10-06.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-06.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-07" },
    { color: "BLUE", upc: "VIS-INSPS-07-07" },
    { color: "CLEAR", upc: "VIS-INSPS-04-07" },
    { color: "GREEN", upc: "VIS-INSPS-05-07" },
    { color: "ORANGE", upc: "VIS-INSPS-06-07" },
    { color: "PINK", upc: "VIS-INSPS-09-07" },
    { color: "PURPLE", upc: "VIS-INSPS-08-07" },
    { color: "RED", upc: "VIS-INSPS-10-07" },
    { color: "WHITE", upc: "VIS-INSPS-02-07" },
    { color: "YELLOW", upc: "VIS-INSPS-01-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-07.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-07.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-07.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-07.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-07.5" },
    { color: "PINK", upc: "VIS-INSPS-09-07.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-07.5" },
    { color: "RED", upc: "VIS-INSPS-10-07.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-07.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-08" },
    { color: "BLUE", upc: "VIS-INSPS-07-08" },
    { color: "CLEAR", upc: "VIS-INSPS-04-08" },
    { color: "GREEN", upc: "VIS-INSPS-05-08" },
    { color: "ORANGE", upc: "VIS-INSPS-06-08" },
    { color: "PINK", upc: "VIS-INSPS-09-08" },
    { color: "PURPLE", upc: "VIS-INSPS-08-08" },
    { color: "RED", upc: "VIS-INSPS-10-08" },
    { color: "WHITE", upc: "VIS-INSPS-02-08" },
    { color: "YELLOW", upc: "VIS-INSPS-01-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-08.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-08.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-08.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-08.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-08.5" },
    { color: "PINK", upc: "VIS-INSPS-09-08.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-08.5" },
    { color: "RED", upc: "VIS-INSPS-10-08.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-08.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-09" },
    { color: "BLUE", upc: "VIS-INSPS-07-09" },
    { color: "CLEAR", upc: "VIS-INSPS-04-09" },
    { color: "GREEN", upc: "VIS-INSPS-05-09" },
    { color: "ORANGE", upc: "VIS-INSPS-06-09" },
    { color: "PINK", upc: "VIS-INSPS-09-09" },
    { color: "PURPLE", upc: "VIS-INSPS-08-09" },
    { color: "RED", upc: "VIS-INSPS-10-09" },
    { color: "WHITE", upc: "VIS-INSPS-02-09" },
    { color: "YELLOW", upc: "VIS-INSPS-01-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "55/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-09.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-09.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-09.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-09.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-09.5" },
    { color: "PINK", upc: "VIS-INSPS-09-09.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-09.5" },
    { color: "RED", upc: "VIS-INSPS-10-09.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-09.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-09.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-10" },
    { color: "BLUE", upc: "VIS-INSPS-07-10" },
    { color: "CLEAR", upc: "VIS-INSPS-04-10" },
    { color: "GREEN", upc: "VIS-INSPS-05-10" },
    { color: "ORANGE", upc: "VIS-INSPS-06-10" },
    { color: "PINK", upc: "VIS-INSPS-09-10" },
    { color: "PURPLE", upc: "VIS-INSPS-08-10" },
    { color: "RED", upc: "VIS-INSPS-10-10" },
    { color: "WHITE", upc: "VIS-INSPS-02-10" },
    { color: "YELLOW", upc: "VIS-INSPS-01-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "57/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-10.5" },
    { color: "BLUE", upc: "VIS-INSPS-07-10.5" },
    { color: "CLEAR", upc: "VIS-INSPS-04-10.5" },
    { color: "GREEN", upc: "VIS-INSPS-05-10.5" },
    { color: "ORANGE", upc: "VIS-INSPS-06-10.5" },
    { color: "PINK", upc: "VIS-INSPS-09-10.5" },
    { color: "PURPLE", upc: "VIS-INSPS-08-10.5" },
    { color: "RED", upc: "VIS-INSPS-10-10.5" },
    { color: "WHITE", upc: "VIS-INSPS-02-10.5" },
    { color: "YELLOW", upc: "VIS-INSPS-01-10.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "VIS-INSPS-03-11" },
    { color: "BLUE", upc: "VIS-INSPS-07-11" },
    { color: "CLEAR", upc: "VIS-INSPS-04-11" },
    { color: "GREEN", upc: "VIS-INSPS-05-11" },
    { color: "ORANGE", upc: "VIS-INSPS-06-11" },
    { color: "PINK", upc: "VIS-INSPS-09-11" },
    { color: "PURPLE", upc: "VIS-INSPS-08-11" },
    { color: "RED", upc: "VIS-INSPS-10-11" },
    { color: "WHITE", upc: "VIS-INSPS-02-11" },
    { color: "YELLOW", upc: "VIS-INSPS-01-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "9/16",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "37/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-00.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "19/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "39/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "5/8",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "41/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "21/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSOPO01" },
    { color: "ORANGE", upc: "VIS-INSOPO-06-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "11/16",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSOPO02" },
    { color: "ORANGE", upc: "VIS-INSOPO-06-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "23/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "47/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "3/4",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "49/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "25/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "51/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "13/16",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "53/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "27/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "55/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-09.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "7/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INS-OPO-00-01" },
    { color: "ORANGE", upc: "VIS-INSOPO-06-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "57/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-10.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "29/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "9/16",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-00" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "37/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-00.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "19/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "39/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-01.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "5/8",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "41/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-02.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "21/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSOPO01" },
    { color: "ORANGE", upc: "VIS-INSOPO-06-03.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "11/16",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "VIS-INSOPO02" },
    { color: "ORANGE", upc: "VIS-INSOPO-06-04.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "23/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "47/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-05.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "3/4",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "49/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-06.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "25/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "51/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-07.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "13/16",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "53/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-08.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "27/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "55/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-09.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "7/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INS-OPO-00-01" },
    { color: "ORANGE", upc: "VIS-INSOPO-06-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "57/64",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-10.5" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL,
  size: "29/32",
  variants: [
    { color: "ORANGE", upc: "VIS-INSOPO-06-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "19/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "5/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "21/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "11/16",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "23/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "3/4",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "25/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "13/16",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "27/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SILICONE,
  size: "7/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSS-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "7/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSSSS" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "37/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-005" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "19/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-010" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "39/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-015" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "5/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-020" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "41/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-025" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "21/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-030" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "43/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-035" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "11/16",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-040" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "45/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-045" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "23/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-050" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "47/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-055" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "3/4",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-060" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "49/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-065" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "25/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-070" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "51/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-075" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "13/16",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-080" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "53/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-085" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "27/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-090" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "55/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-095" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "7/8",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-100" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "57/64",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-105" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "29/32",
  variants: [
    { color: "DEFAULT", upc: "VIS-INSGRAPE-110" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "*",
  variants: [
    { color: "VISE OVAL WITH NUBS GRAPE", upc: "VIS-SEMIV6" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "*",
  variants: [
    { color: "LADY COMBINATIONS VINYL P/S", upc: "VIS-INSLADYPS" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "*",
  variants: [
    { color: "LADY COMBINATIONS VINYL O/PO", upc: "VIS-INSLADYOPO" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "*",
  variants: [
    { color: "LADY COMBINATIONS VINYL P/O", upc: "VIS-INSLADYPO" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-01" },
    { color: "BLACK", upc: "CON-INSSS-08-01" },
    { color: "CERISE", upc: "CON-INSSS-06-01" },
    { color: "GREEN", upc: "CON-INSSS-09-01" },
    { color: "ORANGE", upc: "CON-INSOV-09-01" },
    { color: "ORANGE", upc: "CON-INSSS-03-01" },
    { color: "PINK", upc: "CON-INSOV-06-01" },
    { color: "PINK", upc: "CON-INSSS-10-01" },
    { color: "WHITE", upc: "CON-INSOV-07-01" },
    { color: "WHITE", upc: "CON-INSSS-01-01" },
    { color: "YELLOW", upc: "CON-INSOV-08-01" },
    { color: "YELLOW", upc: "CON-INSSS-02-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-02" },
    { color: "GREEN", upc: "CON-INSSS-09-02" },
    { color: "ORANGE", upc: "CON-INSOV-09-02" },
    { color: "PINK", upc: "CON-INSSS-10-02" },
    { color: "YELLOW", upc: "CON-INSOV-08-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-03" },
    { color: "BLACK", upc: "CON-INSSS-08-03" },
    { color: "CERISE", upc: "CON-INSSS-06-02" },
    { color: "GREEN", upc: "CON-INSSS-09-03" },
    { color: "ORANGE", upc: "CON-INSOV-09-03" },
    { color: "ORANGE", upc: "CON-INSSS-03-02" },
    { color: "PINK", upc: "CON-INSSS-10-03" },
    { color: "WHITE", upc: "CON-INSSS-01-02" },
    { color: "YELLOW", upc: "CON-INSOV-08-03" },
    { color: "YELLOW", upc: "CON-INSSS-02-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-04" },
    { color: "GREEN", upc: "CON-INSSS-09-04" },
    { color: "ORANGE", upc: "CON-INSOV-09-04" },
    { color: "PINK", upc: "CON-INSSS-10-04" },
    { color: "YELLOW", upc: "CON-INSOV-08-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-05" },
    { color: "BLACK", upc: "CON-INSSS-08-05" },
    { color: "CERISE", upc: "CON-INSSS-06-03" },
    { color: "GREEN", upc: "CON-INSSS-09-05" },
    { color: "ORANGE", upc: "CON-INSOV-09-05" },
    { color: "ORANGE", upc: "CON-INSSS-03-03" },
    { color: "PINK", upc: "CON-INSOV-06-05" },
    { color: "PINK", upc: "CON-INSSS-10-05" },
    { color: "RED", upc: "CON-INSSS-05-01" },
    { color: "SILVER", upc: "CON-INSSS-04-01" },
    { color: "WHITE", upc: "CON-INSOV-07-05" },
    { color: "WHITE", upc: "CON-INSSS-01-03" },
    { color: "YELLOW", upc: "CON-INSOV-08-05" },
    { color: "YELLOW", upc: "CON-INSSS-02-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-06" },
    { color: "GREEN", upc: "CON-INSSS-09-06" },
    { color: "ORANGE", upc: "CON-INSOV-09-06" },
    { color: "PINK", upc: "CON-INSSS-10-06" },
    { color: "YELLOW", upc: "CON-INSOV-08-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-07" },
    { color: "BLACK", upc: "CON-INSSS-08-07" },
    { color: "CERISE", upc: "CON-INSSS-06-04" },
    { color: "GREEN", upc: "CON-INSSS-09-07" },
    { color: "ORANGE", upc: "CON-INSOV-09-07" },
    { color: "ORANGE", upc: "CON-INSSS-03-04" },
    { color: "PINK", upc: "CON-INSOV-06-07" },
    { color: "PINK", upc: "CON-INSSS-10-07" },
    { color: "WHITE", upc: "CON-INSOV-07-07" },
    { color: "WHITE", upc: "CON-INSSS-01-04" },
    { color: "YELLOW", upc: "CON-INSOV-08-07" },
    { color: "YELLOW", upc: "CON-INSSS-02-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-08" },
    { color: "GREEN", upc: "CON-INSSS-09-08" },
    { color: "ORANGE", upc: "CON-INSOV-09-08" },
    { color: "PINK", upc: "CON-INSSS-10-08" },
    { color: "YELLOW", upc: "CON-INSOV-08-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-09" },
    { color: "BLACK", upc: "CON-INSSS-08-09" },
    { color: "CERISE", upc: "CON-INSSS-06-05" },
    { color: "CERISE", upc: "CON-INSSS-07-05" },
    { color: "GREEN", upc: "CON-INSSS-09-09" },
    { color: "ORANGE", upc: "CON-INSOV-09-09" },
    { color: "ORANGE", upc: "CON-INSSS-03-05" },
    { color: "PINK", upc: "CON-INSOV-06-09" },
    { color: "PINK", upc: "CON-INSSS-10-09" },
    { color: "WHITE", upc: "CON-INSOV-07-09" },
    { color: "WHITE", upc: "CON-INSSS-01-05" },
    { color: "YELLOW", upc: "CON-INSOV-08-09" },
    { color: "YELLOW", upc: "CON-INSSS-02-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-10" },
    { color: "GREEN", upc: "CON-INSSS-09-10" },
    { color: "ORANGE", upc: "CON-INSOV-09-10" },
    { color: "PINK", upc: "CON-INSSS-10-10" },
    { color: "YELLOW", upc: "CON-INSOV-08-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-11" },
    { color: "CERISE", upc: "CON-INSSS-06-06" },
    { color: "CERISE", upc: "CON-INSSS-07-06" },
    { color: "GREEN", upc: "CON-INSSS-09-11" },
    { color: "ORANGE", upc: "CON-INSOV-09-11" },
    { color: "ORANGE", upc: "CON-INSSS-03-06" },
    { color: "PINK", upc: "CON-INSOV-06-11" },
    { color: "PINK", upc: "CON-INSSS-10-11" },
    { color: "WHITE", upc: "CON-INSOV-07-11" },
    { color: "WHITE", upc: "CON-INSSS-01-06" },
    { color: "YELLOW", upc: "CON-INSOV-08-11" },
    { color: "YELLOW", upc: "CON-INSSS-02-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-12" },
    { color: "GREEN", upc: "CON-INSSS-09-12" },
    { color: "ORANGE", upc: "CON-INSOV-09-12" },
    { color: "PINK", upc: "CON-INSSS-10-12" },
    { color: "YELLOW", upc: "CON-INSOV-08-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-13" },
    { color: "BLACK", upc: "CON-INSSS-08-13" },
    { color: "CERISE", upc: "CON-INSSS-06-07" },
    { color: "CERISE", upc: "CON-INSSS-07-07" },
    { color: "GREEN", upc: "CON-INSSS-09-13" },
    { color: "ORANGE", upc: "CON-INSOV-09-13" },
    { color: "ORANGE", upc: "CON-INSSS-03-07" },
    { color: "PINK", upc: "CON-INSOV-06-13" },
    { color: "PINK", upc: "CON-INSSS-10-13" },
    { color: "WHITE", upc: "CON-INSSS-01-07" },
    { color: "YELLOW", upc: "CON-INSOV-08-13" },
    { color: "YELLOW", upc: "CON-INSSS-02-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-14" },
    { color: "GREEN", upc: "CON-INSSS-09-14" },
    { color: "ORANGE", upc: "CON-INSOV-09-14" },
    { color: "PINK", upc: "CON-INSSS-10-14" },
    { color: "YELLOW", upc: "CON-INSOV-08-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-15" },
    { color: "CERISE", upc: "CON-INSSS-06-08" },
    { color: "CERISE", upc: "CON-INSSS-07-08" },
    { color: "GREEN", upc: "CON-INSSS-09-15" },
    { color: "ORANGE", upc: "CON-INSOV-09-15" },
    { color: "ORANGE", upc: "CON-INSSS-03-08" },
    { color: "PINK", upc: "CON-INSOV-06-15" },
    { color: "PINK", upc: "CON-INSSS-10-15" },
    { color: "WHITE", upc: "CON-INSSS-01-08" },
    { color: "YELLOW", upc: "CON-INSOV-08-15" },
    { color: "YELLOW", upc: "CON-INSSS-02-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "53/64",
  variants: [
    { color: "BLACK", upc: "CON-INSSS-08-16" },
    { color: "GREEN", upc: "CON-INSSS-09-16" },
    { color: "ORANGE", upc: "CON-INSOV-09-16" },
    { color: "PINK", upc: "CON-INSSS-10-16" },
    { color: "YELLOW", upc: "CON-INSOV-08-16" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "27/32",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-17" },
    { color: "BLACK", upc: "CON-INSSS-08-17" },
    { color: "CERISE", upc: "CON-INSSS-06-09" },
    { color: "GREEN", upc: "CON-INSSS-09-17" },
    { color: "ORANGE", upc: "CON-INSOV-09-17" },
    { color: "ORANGE", upc: "CON-INSSS-03-09" },
    { color: "PINK", upc: "CON-INSOV-06-17" },
    { color: "PINK", upc: "CON-INSSS-10-17" },
    { color: "WHITE", upc: "CON-INSOV-07-17" },
    { color: "WHITE", upc: "CON-INSSS-01-09" },
    { color: "YELLOW", upc: "CON-INSOV-08-17" },
    { color: "YELLOW", upc: "CON-INSSS-02-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "7/8",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-18" },
    { color: "BLACK", upc: "CON-INSSS-08-18" },
    { color: "CERISE", upc: "CON-INSSS-06-10" },
    { color: "GREEN", upc: "CON-INSSS-09-18" },
    { color: "ORANGE", upc: "CON-INSOV-09-18" },
    { color: "ORANGE", upc: "CON-INSSS-03-10" },
    { color: "PINK", upc: "CON-INSOV-06-18" },
    { color: "PINK", upc: "CON-INSSS-10-18" },
    { color: "RED", upc: "CON-INSSS-05-02" },
    { color: "WHITE", upc: "CON-INSSS-01-10" },
    { color: "YELLOW", upc: "CON-INSOV-08-18" },
    { color: "YELLOW", upc: "CON-INSSS-02-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "29/32",
  variants: [
    { color: "BLACK", upc: "CON-INSOV-05-19" },
    { color: "BLACK", upc: "CON-INSSS-08-19" },
    { color: "CERISE", upc: "CON-INSSS-06-11" },
    { color: "GREEN", upc: "CON-INSSS-09-19" },
    { color: "ORANGE", upc: "CON-INSOV-09-19" },
    { color: "ORANGE", upc: "CON-INSSS-03-11" },
    { color: "PINK", upc: "CON-INSOV-06-19" },
    { color: "PINK", upc: "CON-INSSS-10-19" },
    { color: "WHITE", upc: "CON-INSSS-01-11" },
    { color: "YELLOW", upc: "CON-INSOV-08-19" },
    { color: "YELLOW", upc: "CON-INSSS-02-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "19/32",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "5/8",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "21/32",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "11/16",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "23/32",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "3/4",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "25/32",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "13/16",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "27/32",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "7/8",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "29/32",
  variants: [
    { color: "CERISE", upc: "CON-INSSEMI-04-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-01" },
    { color: "BLUE", upc: "JOP-PFO-06-01" },
    { color: "GREEN", upc: "JOP-PFO-05-01" },
    { color: "ORANGE", upc: "JOP-PFO-04-01" },
    { color: "PINK", upc: "JOP-PFO-08-01" },
    { color: "PURPLE", upc: "JOP-PFO-09-01" },
    { color: "RED", upc: "JOP-PFO-07-01" },
    { color: "WHITE", upc: "JOP-PFO-02-01" },
    { color: "YELLOW", upc: "JOP-PFO-03-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-02" },
    { color: "BLUE", upc: "JOP-PFO-06-02" },
    { color: "GREEN", upc: "JOP-PFO-05-02" },
    { color: "ORANGE", upc: "JOP-PFO-04-02" },
    { color: "PINK", upc: "JOP-PFO-08-02" },
    { color: "PURPLE", upc: "JOP-PFO-09-02" },
    { color: "RED", upc: "JOP-PFO-07-02" },
    { color: "WHITE", upc: "JOP-PFO-02-02" },
    { color: "YELLOW", upc: "JOP-PFO-03-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-03" },
    { color: "BLUE", upc: "JOP-PFO-06-03" },
    { color: "GREEN", upc: "JOP-PFO-05-03" },
    { color: "ORANGE", upc: "JOP-PFO-04-03" },
    { color: "PINK", upc: "JOP-PFO-08-03" },
    { color: "PURPLE", upc: "JOP-PFO-09-03" },
    { color: "RED", upc: "JOP-PFO-07-03" },
    { color: "WHITE", upc: "JOP-PFO-02-03" },
    { color: "YELLOW", upc: "JOP-PFO-03-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-04" },
    { color: "BLUE", upc: "JOP-PFO-06-04" },
    { color: "GREEN", upc: "JOP-PFO-05-04" },
    { color: "ORANGE", upc: "JOP-PFO-04-04" },
    { color: "PINK", upc: "JOP-PFO-08-04" },
    { color: "PURPLE", upc: "JOP-PFO-09-04" },
    { color: "RED", upc: "JOP-PFO-07-04" },
    { color: "WHITE", upc: "JOP-PFO-02-04" },
    { color: "YELLOW", upc: "JOP-PFO-03-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-05" },
    { color: "BLUE", upc: "JOP-PFO-06-05" },
    { color: "GREEN", upc: "JOP-PFO-05-05" },
    { color: "ORANGE", upc: "JOP-PFO-04-05" },
    { color: "PINK", upc: "JOP-PFO-08-05" },
    { color: "PURPLE", upc: "JOP-PFO-09-05" },
    { color: "RED", upc: "JOP-PFO-07-05" },
    { color: "WHITE", upc: "JOP-PFO-02-05" },
    { color: "YELLOW", upc: "JOP-PFO-03-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-06" },
    { color: "BLUE", upc: "JOP-PFO-06-06" },
    { color: "GREEN", upc: "JOP-PFO-05-06" },
    { color: "ORANGE", upc: "JOP-PFO-04-06" },
    { color: "PINK", upc: "JOP-PFO-08-06" },
    { color: "PURPLE", upc: "JOP-PFO-09-06" },
    { color: "RED", upc: "JOP-PFO-07-06" },
    { color: "WHITE", upc: "JOP-PFO-02-06" },
    { color: "YELLOW", upc: "JOP-PFO-03-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-07" },
    { color: "BLUE", upc: "JOP-PFO-06-07" },
    { color: "GREEN", upc: "JOP-PFO-05-07" },
    { color: "ORANGE", upc: "JOP-PFO-04-07" },
    { color: "PINK", upc: "JOP-PFO-08-07" },
    { color: "PURPLE", upc: "JOP-PFO-09-07" },
    { color: "RED", upc: "JOP-PFO-07-07" },
    { color: "WHITE", upc: "JOP-PFO-02-07" },
    { color: "YELLOW", upc: "JOP-PFO-03-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-08" },
    { color: "BLUE", upc: "JOP-PFO-06-08" },
    { color: "GREEN", upc: "JOP-PFO-05-08" },
    { color: "ORANGE", upc: "JOP-PFO-04-08" },
    { color: "PINK", upc: "JOP-PFO-08-08" },
    { color: "PURPLE", upc: "JOP-PFO-09-08" },
    { color: "RED", upc: "JOP-PFO-07-08" },
    { color: "WHITE", upc: "JOP-PFO-02-08" },
    { color: "YELLOW", upc: "JOP-PFO-03-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-09" },
    { color: "BLUE", upc: "JOP-PFO-06-09" },
    { color: "GREEN", upc: "JOP-PFO-05-09" },
    { color: "ORANGE", upc: "JOP-PFO-04-09" },
    { color: "PINK", upc: "JOP-PFO-08-09" },
    { color: "PURPLE", upc: "JOP-PFO-09-09" },
    { color: "RED", upc: "JOP-PFO-07-09" },
    { color: "WHITE", upc: "JOP-PFO-02-09" },
    { color: "YELLOW", upc: "JOP-PFO-03-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-10" },
    { color: "BLUE", upc: "JOP-PFO-06-10" },
    { color: "GREEN", upc: "JOP-PFO-05-10" },
    { color: "ORANGE", upc: "JOP-PFO-04-10" },
    { color: "PINK", upc: "JOP-PFO-08-10" },
    { color: "PURPLE", upc: "JOP-PFO-09-10" },
    { color: "RED", upc: "JOP-PFO-07-10" },
    { color: "WHITE", upc: "JOP-PFO-02-10" },
    { color: "YELLOW", upc: "JOP-PFO-03-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-11" },
    { color: "BLUE", upc: "JOP-PFO-06-11" },
    { color: "GREEN", upc: "JOP-PFO-05-11" },
    { color: "ORANGE", upc: "JOP-PFO-04-11" },
    { color: "PINK", upc: "JOP-PFO-08-11" },
    { color: "PURPLE", upc: "JOP-PFO-09-11" },
    { color: "RED", upc: "JOP-PFO-07-11" },
    { color: "WHITE", upc: "JOP-PFO-02-11" },
    { color: "YELLOW", upc: "JOP-PFO-03-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-12" },
    { color: "BLUE", upc: "JOP-PFO-06-12" },
    { color: "GREEN", upc: "JOP-PFO-05-12" },
    { color: "ORANGE", upc: "JOP-PFO-04-12" },
    { color: "PINK", upc: "JOP-PFO-08-12" },
    { color: "PURPLE", upc: "JOP-PFO-09-12" },
    { color: "RED", upc: "JOP-PFO-07-12" },
    { color: "WHITE", upc: "JOP-PFO-02-12" },
    { color: "YELLOW", upc: "JOP-PFO-03-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-13" },
    { color: "BLUE", upc: "JOP-PFO-06-13" },
    { color: "GREEN", upc: "JOP-PFO-05-13" },
    { color: "ORANGE", upc: "JOP-PFO-04-13" },
    { color: "PINK", upc: "JOP-PFO-08-13" },
    { color: "PURPLE", upc: "JOP-PFO-09-13" },
    { color: "RED", upc: "JOP-PFO-07-13" },
    { color: "WHITE", upc: "JOP-PFO-02-13" },
    { color: "YELLOW", upc: "JOP-PFO-03-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-14" },
    { color: "BLUE", upc: "JOP-PFO-06-14" },
    { color: "GREEN", upc: "JOP-PFO-05-14" },
    { color: "ORANGE", upc: "JOP-PFO-04-14" },
    { color: "PINK", upc: "JOP-PFO-08-14" },
    { color: "PURPLE", upc: "JOP-PFO-09-14" },
    { color: "RED", upc: "JOP-PFO-07-14" },
    { color: "WHITE", upc: "JOP-PFO-02-14" },
    { color: "YELLOW", upc: "JOP-PFO-03-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_LIFT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-15" },
    { color: "BLUE", upc: "JOP-PFO-06-15" },
    { color: "GREEN", upc: "JOP-PFO-05-15" },
    { color: "ORANGE", upc: "JOP-PFO-04-15" },
    { color: "PINK", upc: "JOP-PFO-08-15" },
    { color: "PURPLE", upc: "JOP-PFO-09-15" },
    { color: "RED", upc: "JOP-PFO-07-15" },
    { color: "WHITE", upc: "JOP-PFO-02-15" },
    { color: "YELLOW", upc: "JOP-PFO-03-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-01" },
    { color: "BLUE", upc: "JOP-PFO-06-01" },
    { color: "GREEN", upc: "JOP-PFO-05-01" },
    { color: "ORANGE", upc: "JOP-PFO-04-01" },
    { color: "PINK", upc: "JOP-PFO-08-01" },
    { color: "PURPLE", upc: "JOP-PFO-09-01" },
    { color: "RED", upc: "JOP-PFO-07-01" },
    { color: "WHITE", upc: "JOP-PFO-02-01" },
    { color: "YELLOW", upc: "JOP-PFO-03-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-02" },
    { color: "BLUE", upc: "JOP-PFO-06-02" },
    { color: "GREEN", upc: "JOP-PFO-05-02" },
    { color: "ORANGE", upc: "JOP-PFO-04-02" },
    { color: "PINK", upc: "JOP-PFO-08-02" },
    { color: "PURPLE", upc: "JOP-PFO-09-02" },
    { color: "RED", upc: "JOP-PFO-07-02" },
    { color: "WHITE", upc: "JOP-PFO-02-02" },
    { color: "YELLOW", upc: "JOP-PFO-03-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-03" },
    { color: "BLUE", upc: "JOP-PFO-06-03" },
    { color: "GREEN", upc: "JOP-PFO-05-03" },
    { color: "ORANGE", upc: "JOP-PFO-04-03" },
    { color: "PINK", upc: "JOP-PFO-08-03" },
    { color: "PURPLE", upc: "JOP-PFO-09-03" },
    { color: "RED", upc: "JOP-PFO-07-03" },
    { color: "WHITE", upc: "JOP-PFO-02-03" },
    { color: "YELLOW", upc: "JOP-PFO-03-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-04" },
    { color: "BLUE", upc: "JOP-PFO-06-04" },
    { color: "GREEN", upc: "JOP-PFO-05-04" },
    { color: "ORANGE", upc: "JOP-PFO-04-04" },
    { color: "PINK", upc: "JOP-PFO-08-04" },
    { color: "PURPLE", upc: "JOP-PFO-09-04" },
    { color: "RED", upc: "JOP-PFO-07-04" },
    { color: "WHITE", upc: "JOP-PFO-02-04" },
    { color: "YELLOW", upc: "JOP-PFO-03-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-05" },
    { color: "BLUE", upc: "JOP-PFO-06-05" },
    { color: "GREEN", upc: "JOP-PFO-05-05" },
    { color: "ORANGE", upc: "JOP-PFO-04-05" },
    { color: "PINK", upc: "JOP-PFO-08-05" },
    { color: "PURPLE", upc: "JOP-PFO-09-05" },
    { color: "RED", upc: "JOP-PFO-07-05" },
    { color: "WHITE", upc: "JOP-PFO-02-05" },
    { color: "YELLOW", upc: "JOP-PFO-03-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-06" },
    { color: "BLUE", upc: "JOP-PFO-06-06" },
    { color: "GREEN", upc: "JOP-PFO-05-06" },
    { color: "ORANGE", upc: "JOP-PFO-04-06" },
    { color: "PINK", upc: "JOP-PFO-08-06" },
    { color: "PURPLE", upc: "JOP-PFO-09-06" },
    { color: "RED", upc: "JOP-PFO-07-06" },
    { color: "WHITE", upc: "JOP-PFO-02-06" },
    { color: "YELLOW", upc: "JOP-PFO-03-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-07" },
    { color: "BLUE", upc: "JOP-PFO-06-07" },
    { color: "GREEN", upc: "JOP-PFO-05-07" },
    { color: "ORANGE", upc: "JOP-PFO-04-07" },
    { color: "PINK", upc: "JOP-PFO-08-07" },
    { color: "PURPLE", upc: "JOP-PFO-09-07" },
    { color: "RED", upc: "JOP-PFO-07-07" },
    { color: "WHITE", upc: "JOP-PFO-02-07" },
    { color: "YELLOW", upc: "JOP-PFO-03-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-08" },
    { color: "BLUE", upc: "JOP-PFO-06-08" },
    { color: "GREEN", upc: "JOP-PFO-05-08" },
    { color: "ORANGE", upc: "JOP-PFO-04-08" },
    { color: "PINK", upc: "JOP-PFO-08-08" },
    { color: "PURPLE", upc: "JOP-PFO-09-08" },
    { color: "RED", upc: "JOP-PFO-07-08" },
    { color: "WHITE", upc: "JOP-PFO-02-08" },
    { color: "YELLOW", upc: "JOP-PFO-03-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-09" },
    { color: "BLUE", upc: "JOP-PFO-06-09" },
    { color: "GREEN", upc: "JOP-PFO-05-09" },
    { color: "ORANGE", upc: "JOP-PFO-04-09" },
    { color: "PINK", upc: "JOP-PFO-08-09" },
    { color: "PURPLE", upc: "JOP-PFO-09-09" },
    { color: "RED", upc: "JOP-PFO-07-09" },
    { color: "WHITE", upc: "JOP-PFO-02-09" },
    { color: "YELLOW", upc: "JOP-PFO-03-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-10" },
    { color: "BLUE", upc: "JOP-PFO-06-10" },
    { color: "GREEN", upc: "JOP-PFO-05-10" },
    { color: "ORANGE", upc: "JOP-PFO-04-10" },
    { color: "PINK", upc: "JOP-PFO-08-10" },
    { color: "PURPLE", upc: "JOP-PFO-09-10" },
    { color: "RED", upc: "JOP-PFO-07-10" },
    { color: "WHITE", upc: "JOP-PFO-02-10" },
    { color: "YELLOW", upc: "JOP-PFO-03-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-11" },
    { color: "BLUE", upc: "JOP-PFO-06-11" },
    { color: "GREEN", upc: "JOP-PFO-05-11" },
    { color: "ORANGE", upc: "JOP-PFO-04-11" },
    { color: "PINK", upc: "JOP-PFO-08-11" },
    { color: "PURPLE", upc: "JOP-PFO-09-11" },
    { color: "RED", upc: "JOP-PFO-07-11" },
    { color: "WHITE", upc: "JOP-PFO-02-11" },
    { color: "YELLOW", upc: "JOP-PFO-03-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-12" },
    { color: "BLUE", upc: "JOP-PFO-06-12" },
    { color: "GREEN", upc: "JOP-PFO-05-12" },
    { color: "ORANGE", upc: "JOP-PFO-04-12" },
    { color: "PINK", upc: "JOP-PFO-08-12" },
    { color: "PURPLE", upc: "JOP-PFO-09-12" },
    { color: "RED", upc: "JOP-PFO-07-12" },
    { color: "WHITE", upc: "JOP-PFO-02-12" },
    { color: "YELLOW", upc: "JOP-PFO-03-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-13" },
    { color: "BLUE", upc: "JOP-PFO-06-13" },
    { color: "GREEN", upc: "JOP-PFO-05-13" },
    { color: "ORANGE", upc: "JOP-PFO-04-13" },
    { color: "PINK", upc: "JOP-PFO-08-13" },
    { color: "PURPLE", upc: "JOP-PFO-09-13" },
    { color: "RED", upc: "JOP-PFO-07-13" },
    { color: "WHITE", upc: "JOP-PFO-02-13" },
    { color: "YELLOW", upc: "JOP-PFO-03-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-14" },
    { color: "BLUE", upc: "JOP-PFO-06-14" },
    { color: "GREEN", upc: "JOP-PFO-05-14" },
    { color: "ORANGE", upc: "JOP-PFO-04-14" },
    { color: "PINK", upc: "JOP-PFO-08-14" },
    { color: "PURPLE", upc: "JOP-PFO-09-14" },
    { color: "RED", upc: "JOP-PFO-07-14" },
    { color: "WHITE", upc: "JOP-PFO-02-14" },
    { color: "YELLOW", upc: "JOP-PFO-03-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "JOP-PFO-01-15" },
    { color: "BLUE", upc: "JOP-PFO-06-15" },
    { color: "GREEN", upc: "JOP-PFO-05-15" },
    { color: "ORANGE", upc: "JOP-PFO-04-15" },
    { color: "PINK", upc: "JOP-PFO-08-15" },
    { color: "PURPLE", upc: "JOP-PFO-09-15" },
    { color: "RED", upc: "JOP-PFO-07-15" },
    { color: "WHITE", upc: "JOP-PFO-02-15" },
    { color: "YELLOW", upc: "JOP-PFO-03-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-01" },
    { color: "BLUE", upc: "JOP-P0D-06-01" },
    { color: "GREEN", upc: "JOP-P0D-05-01" },
    { color: "ORANGE", upc: "JOP-P0D-04-01" },
    { color: "PINK", upc: "JOP-P0D-08-01" },
    { color: "PURPLE", upc: "JOP-P0D-09-01" },
    { color: "RED", upc: "JOP-P0D-07-01" },
    { color: "WHITE", upc: "JOP-P0D-02-01" },
    { color: "YELLOW", upc: "JOP-P0D-03-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-02" },
    { color: "BLUE", upc: "JOP-P0D-06-02" },
    { color: "GREEN", upc: "JOP-P0D-05-02" },
    { color: "ORANGE", upc: "JOP-P0D-04-02" },
    { color: "PINK", upc: "JOP-P0D-08-02" },
    { color: "PURPLE", upc: "JOP-P0D-09-02" },
    { color: "RED", upc: "JOP-P0D-07-02" },
    { color: "WHITE", upc: "JOP-P0D-02-02" },
    { color: "YELLOW", upc: "JOP-P0D-03-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-03" },
    { color: "BLUE", upc: "JOP-P0D-06-03" },
    { color: "GREEN", upc: "JOP-P0D-05-03" },
    { color: "ORANGE", upc: "JOP-P0D-04-03" },
    { color: "PINK", upc: "JOP-P0D-08-03" },
    { color: "PURPLE", upc: "JOP-P0D-09-03" },
    { color: "RED", upc: "JOP-P0D-07-03" },
    { color: "WHITE", upc: "JOP-P0D-02-03" },
    { color: "YELLOW", upc: "JOP-P0D-03-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-04" },
    { color: "BLUE", upc: "JOP-P0D-06-04" },
    { color: "GREEN", upc: "JOP-P0D-05-04" },
    { color: "ORANGE", upc: "JOP-P0D-04-04" },
    { color: "PINK", upc: "JOP-P0D-08-04" },
    { color: "PURPLE", upc: "JOP-P0D-09-04" },
    { color: "RED", upc: "JOP-P0D-07-04" },
    { color: "WHITE", upc: "JOP-P0D-02-04" },
    { color: "YELLOW", upc: "JOP-P0D-03-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-05" },
    { color: "BLUE", upc: "JOP-P0D-06-05" },
    { color: "GREEN", upc: "JOP-P0D-05-05" },
    { color: "ORANGE", upc: "JOP-P0D-04-05" },
    { color: "PINK", upc: "JOP-P0D-08-05" },
    { color: "PURPLE", upc: "JOP-P0D-09-05" },
    { color: "RED", upc: "JOP-P0D-07-05" },
    { color: "WHITE", upc: "JOP-P0D-02-05" },
    { color: "YELLOW", upc: "JOP-P0D-03-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-06" },
    { color: "BLUE", upc: "JOP-P0D-06-06" },
    { color: "GREEN", upc: "JOP-P0D-05-06" },
    { color: "ORANGE", upc: "JOP-P0D-04-06" },
    { color: "PINK", upc: "JOP-P0D-08-06" },
    { color: "PURPLE", upc: "JOP-P0D-09-06" },
    { color: "RED", upc: "JOP-P0D-07-06" },
    { color: "WHITE", upc: "JOP-P0D-02-06" },
    { color: "YELLOW", upc: "JOP-P0D-03-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-07" },
    { color: "BLUE", upc: "JOP-P0D-06-07" },
    { color: "GREEN", upc: "JOP-P0D-05-07" },
    { color: "ORANGE", upc: "JOP-P0D-04-07" },
    { color: "PINK", upc: "JOP-P0D-08-07" },
    { color: "PURPLE", upc: "JOP-P0D-09-07" },
    { color: "RED", upc: "JOP-P0D-07-07" },
    { color: "WHITE", upc: "JOP-P0D-02-07" },
    { color: "YELLOW", upc: "JOP-P0D-03-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-08" },
    { color: "BLUE", upc: "JOP-P0D-06-08" },
    { color: "GREEN", upc: "JOP-P0D-05-08" },
    { color: "ORANGE", upc: "JOP-P0D-04-08" },
    { color: "PINK", upc: "JOP-P0D-08-08" },
    { color: "PURPLE", upc: "JOP-P0D-09-08" },
    { color: "RED", upc: "JOP-P0D-07-08" },
    { color: "WHITE", upc: "JOP-P0D-02-08" },
    { color: "YELLOW", upc: "JOP-P0D-03-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-09" },
    { color: "BLUE", upc: "JOP-P0D-06-09" },
    { color: "GREEN", upc: "JOP-P0D-05-09" },
    { color: "ORANGE", upc: "JOP-P0D-04-09" },
    { color: "PINK", upc: "JOP-P0D-08-09" },
    { color: "PURPLE", upc: "JOP-P0D-09-09" },
    { color: "RED", upc: "JOP-P0D-07-09" },
    { color: "WHITE", upc: "JOP-P0D-02-09" },
    { color: "YELLOW", upc: "JOP-P0D-03-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-10" },
    { color: "BLUE", upc: "JOP-P0D-06-10" },
    { color: "GREEN", upc: "JOP-P0D-05-10" },
    { color: "ORANGE", upc: "JOP-P0D-04-10" },
    { color: "PINK", upc: "JOP-P0D-08-10" },
    { color: "PURPLE", upc: "JOP-P0D-09-10" },
    { color: "RED", upc: "JOP-P0D-07-10" },
    { color: "WHITE", upc: "JOP-P0D-02-10" },
    { color: "YELLOW", upc: "JOP-P0D-03-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-11" },
    { color: "BLUE", upc: "JOP-P0D-06-11" },
    { color: "GREEN", upc: "JOP-P0D-05-11" },
    { color: "ORANGE", upc: "JOP-P0D-04-11" },
    { color: "PINK", upc: "JOP-P0D-08-11" },
    { color: "PURPLE", upc: "JOP-P0D-09-11" },
    { color: "RED", upc: "JOP-P0D-07-11" },
    { color: "WHITE", upc: "JOP-P0D-02-11" },
    { color: "YELLOW", upc: "JOP-P0D-03-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-12" },
    { color: "BLUE", upc: "JOP-P0D-06-12" },
    { color: "GREEN", upc: "JOP-P0D-05-12" },
    { color: "ORANGE", upc: "JOP-P0D-04-12" },
    { color: "PINK", upc: "JOP-P0D-08-12" },
    { color: "PURPLE", upc: "JOP-P0D-09-12" },
    { color: "RED", upc: "JOP-P0D-07-12" },
    { color: "WHITE", upc: "JOP-P0D-02-12" },
    { color: "YELLOW", upc: "JOP-P0D-03-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-13" },
    { color: "BLUE", upc: "JOP-P0D-06-13" },
    { color: "GREEN", upc: "JOP-P0D-05-13" },
    { color: "ORANGE", upc: "JOP-P0D-04-13" },
    { color: "PINK", upc: "JOP-P0D-08-13" },
    { color: "PURPLE", upc: "JOP-P0D-09-13" },
    { color: "RED", upc: "JOP-P0D-07-13" },
    { color: "WHITE", upc: "JOP-P0D-02-13" },
    { color: "YELLOW", upc: "JOP-P0D-03-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-14" },
    { color: "BLUE", upc: "JOP-P0D-06-14" },
    { color: "GREEN", upc: "JOP-P0D-05-14" },
    { color: "ORANGE", upc: "JOP-P0D-04-14" },
    { color: "PINK", upc: "JOP-P0D-08-14" },
    { color: "PURPLE", upc: "JOP-P0D-09-14" },
    { color: "RED", upc: "JOP-P0D-07-14" },
    { color: "WHITE", upc: "JOP-P0D-02-14" },
    { color: "YELLOW", upc: "JOP-P0D-03-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-15" },
    { color: "BLUE", upc: "JOP-P0D-06-15" },
    { color: "GREEN", upc: "JOP-P0D-05-15" },
    { color: "ORANGE", upc: "JOP-P0D-04-15" },
    { color: "PINK", upc: "JOP-P0D-08-15" },
    { color: "PURPLE", upc: "JOP-P0D-09-15" },
    { color: "RED", upc: "JOP-P0D-07-15" },
    { color: "WHITE", upc: "JOP-P0D-02-15" },
    { color: "YELLOW", upc: "JOP-P0D-03-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-01" },
    { color: "BLUE", upc: "JOP-P0D-06-01" },
    { color: "GREEN", upc: "JOP-P0D-05-01" },
    { color: "ORANGE", upc: "JOP-P0D-04-01" },
    { color: "PINK", upc: "JOP-P0D-08-01" },
    { color: "PURPLE", upc: "JOP-P0D-09-01" },
    { color: "RED", upc: "JOP-P0D-07-01" },
    { color: "WHITE", upc: "JOP-P0D-02-01" },
    { color: "YELLOW", upc: "JOP-P0D-03-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-02" },
    { color: "BLUE", upc: "JOP-P0D-06-02" },
    { color: "GREEN", upc: "JOP-P0D-05-02" },
    { color: "ORANGE", upc: "JOP-P0D-04-02" },
    { color: "PINK", upc: "JOP-P0D-08-02" },
    { color: "PURPLE", upc: "JOP-P0D-09-02" },
    { color: "RED", upc: "JOP-P0D-07-02" },
    { color: "WHITE", upc: "JOP-P0D-02-02" },
    { color: "YELLOW", upc: "JOP-P0D-03-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-03" },
    { color: "BLUE", upc: "JOP-P0D-06-03" },
    { color: "GREEN", upc: "JOP-P0D-05-03" },
    { color: "ORANGE", upc: "JOP-P0D-04-03" },
    { color: "PINK", upc: "JOP-P0D-08-03" },
    { color: "PURPLE", upc: "JOP-P0D-09-03" },
    { color: "RED", upc: "JOP-P0D-07-03" },
    { color: "WHITE", upc: "JOP-P0D-02-03" },
    { color: "YELLOW", upc: "JOP-P0D-03-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-04" },
    { color: "BLUE", upc: "JOP-P0D-06-04" },
    { color: "GREEN", upc: "JOP-P0D-05-04" },
    { color: "ORANGE", upc: "JOP-P0D-04-04" },
    { color: "PINK", upc: "JOP-P0D-08-04" },
    { color: "PURPLE", upc: "JOP-P0D-09-04" },
    { color: "RED", upc: "JOP-P0D-07-04" },
    { color: "WHITE", upc: "JOP-P0D-02-04" },
    { color: "YELLOW", upc: "JOP-P0D-03-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-05" },
    { color: "BLUE", upc: "JOP-P0D-06-05" },
    { color: "GREEN", upc: "JOP-P0D-05-05" },
    { color: "ORANGE", upc: "JOP-P0D-04-05" },
    { color: "PINK", upc: "JOP-P0D-08-05" },
    { color: "PURPLE", upc: "JOP-P0D-09-05" },
    { color: "RED", upc: "JOP-P0D-07-05" },
    { color: "WHITE", upc: "JOP-P0D-02-05" },
    { color: "YELLOW", upc: "JOP-P0D-03-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-06" },
    { color: "BLUE", upc: "JOP-P0D-06-06" },
    { color: "GREEN", upc: "JOP-P0D-05-06" },
    { color: "ORANGE", upc: "JOP-P0D-04-06" },
    { color: "PINK", upc: "JOP-P0D-08-06" },
    { color: "PURPLE", upc: "JOP-P0D-09-06" },
    { color: "RED", upc: "JOP-P0D-07-06" },
    { color: "WHITE", upc: "JOP-P0D-02-06" },
    { color: "YELLOW", upc: "JOP-P0D-03-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-07" },
    { color: "BLUE", upc: "JOP-P0D-06-07" },
    { color: "GREEN", upc: "JOP-P0D-05-07" },
    { color: "ORANGE", upc: "JOP-P0D-04-07" },
    { color: "PINK", upc: "JOP-P0D-08-07" },
    { color: "PURPLE", upc: "JOP-P0D-09-07" },
    { color: "RED", upc: "JOP-P0D-07-07" },
    { color: "WHITE", upc: "JOP-P0D-02-07" },
    { color: "YELLOW", upc: "JOP-P0D-03-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-08" },
    { color: "BLUE", upc: "JOP-P0D-06-08" },
    { color: "GREEN", upc: "JOP-P0D-05-08" },
    { color: "ORANGE", upc: "JOP-P0D-04-08" },
    { color: "PINK", upc: "JOP-P0D-08-08" },
    { color: "PURPLE", upc: "JOP-P0D-09-08" },
    { color: "RED", upc: "JOP-P0D-07-08" },
    { color: "WHITE", upc: "JOP-P0D-02-08" },
    { color: "YELLOW", upc: "JOP-P0D-03-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-09" },
    { color: "BLUE", upc: "JOP-P0D-06-09" },
    { color: "GREEN", upc: "JOP-P0D-05-09" },
    { color: "ORANGE", upc: "JOP-P0D-04-09" },
    { color: "PINK", upc: "JOP-P0D-08-09" },
    { color: "PURPLE", upc: "JOP-P0D-09-09" },
    { color: "RED", upc: "JOP-P0D-07-09" },
    { color: "WHITE", upc: "JOP-P0D-02-09" },
    { color: "YELLOW", upc: "JOP-P0D-03-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-10" },
    { color: "BLUE", upc: "JOP-P0D-06-10" },
    { color: "GREEN", upc: "JOP-P0D-05-10" },
    { color: "ORANGE", upc: "JOP-P0D-04-10" },
    { color: "PINK", upc: "JOP-P0D-08-10" },
    { color: "PURPLE", upc: "JOP-P0D-09-10" },
    { color: "RED", upc: "JOP-P0D-07-10" },
    { color: "WHITE", upc: "JOP-P0D-02-10" },
    { color: "YELLOW", upc: "JOP-P0D-03-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-11" },
    { color: "BLUE", upc: "JOP-P0D-06-11" },
    { color: "GREEN", upc: "JOP-P0D-05-11" },
    { color: "ORANGE", upc: "JOP-P0D-04-11" },
    { color: "PINK", upc: "JOP-P0D-08-11" },
    { color: "PURPLE", upc: "JOP-P0D-09-11" },
    { color: "RED", upc: "JOP-P0D-07-11" },
    { color: "WHITE", upc: "JOP-P0D-02-11" },
    { color: "YELLOW", upc: "JOP-P0D-03-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-12" },
    { color: "BLUE", upc: "JOP-P0D-06-12" },
    { color: "GREEN", upc: "JOP-P0D-05-12" },
    { color: "ORANGE", upc: "JOP-P0D-04-12" },
    { color: "PINK", upc: "JOP-P0D-08-12" },
    { color: "PURPLE", upc: "JOP-P0D-09-12" },
    { color: "RED", upc: "JOP-P0D-07-12" },
    { color: "WHITE", upc: "JOP-P0D-02-12" },
    { color: "YELLOW", upc: "JOP-P0D-03-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-13" },
    { color: "BLUE", upc: "JOP-P0D-06-13" },
    { color: "GREEN", upc: "JOP-P0D-05-13" },
    { color: "ORANGE", upc: "JOP-P0D-04-13" },
    { color: "PINK", upc: "JOP-P0D-08-13" },
    { color: "PURPLE", upc: "JOP-P0D-09-13" },
    { color: "RED", upc: "JOP-P0D-07-13" },
    { color: "WHITE", upc: "JOP-P0D-02-13" },
    { color: "YELLOW", upc: "JOP-P0D-03-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-14" },
    { color: "BLUE", upc: "JOP-P0D-06-14" },
    { color: "GREEN", upc: "JOP-P0D-05-14" },
    { color: "ORANGE", upc: "JOP-P0D-04-14" },
    { color: "PINK", upc: "JOP-P0D-08-14" },
    { color: "PURPLE", upc: "JOP-P0D-09-14" },
    { color: "RED", upc: "JOP-P0D-07-14" },
    { color: "WHITE", upc: "JOP-P0D-02-14" },
    { color: "YELLOW", upc: "JOP-P0D-03-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-15" },
    { color: "BLUE", upc: "JOP-P0D-06-15" },
    { color: "GREEN", upc: "JOP-P0D-05-15" },
    { color: "ORANGE", upc: "JOP-P0D-04-15" },
    { color: "PINK", upc: "JOP-P0D-08-15" },
    { color: "PURPLE", upc: "JOP-P0D-09-15" },
    { color: "RED", upc: "JOP-P0D-07-15" },
    { color: "WHITE", upc: "JOP-P0D-02-15" },
    { color: "YELLOW", upc: "JOP-P0D-03-15" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "19/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-01" },
    { color: "BLUE", upc: "JOP-P0D-06-01" },
    { color: "GREEN", upc: "JOP-P0D-05-01" },
    { color: "ORANGE", upc: "JOP-P0D-04-01" },
    { color: "PINK", upc: "JOP-P0D-08-01" },
    { color: "PURPLE", upc: "JOP-P0D-09-01" },
    { color: "RED", upc: "JOP-P0D-07-01" },
    { color: "WHITE", upc: "JOP-P0D-02-01" },
    { color: "YELLOW", upc: "JOP-P0D-03-01" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "39/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-02" },
    { color: "BLUE", upc: "JOP-P0D-06-02" },
    { color: "GREEN", upc: "JOP-P0D-05-02" },
    { color: "ORANGE", upc: "JOP-P0D-04-02" },
    { color: "PINK", upc: "JOP-P0D-08-02" },
    { color: "PURPLE", upc: "JOP-P0D-09-02" },
    { color: "RED", upc: "JOP-P0D-07-02" },
    { color: "WHITE", upc: "JOP-P0D-02-02" },
    { color: "YELLOW", upc: "JOP-P0D-03-02" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "5/8",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-03" },
    { color: "BLUE", upc: "JOP-P0D-06-03" },
    { color: "GREEN", upc: "JOP-P0D-05-03" },
    { color: "ORANGE", upc: "JOP-P0D-04-03" },
    { color: "PINK", upc: "JOP-P0D-08-03" },
    { color: "PURPLE", upc: "JOP-P0D-09-03" },
    { color: "RED", upc: "JOP-P0D-07-03" },
    { color: "WHITE", upc: "JOP-P0D-02-03" },
    { color: "YELLOW", upc: "JOP-P0D-03-03" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "41/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-04" },
    { color: "BLUE", upc: "JOP-P0D-06-04" },
    { color: "GREEN", upc: "JOP-P0D-05-04" },
    { color: "ORANGE", upc: "JOP-P0D-04-04" },
    { color: "PINK", upc: "JOP-P0D-08-04" },
    { color: "PURPLE", upc: "JOP-P0D-09-04" },
    { color: "RED", upc: "JOP-P0D-07-04" },
    { color: "WHITE", upc: "JOP-P0D-02-04" },
    { color: "YELLOW", upc: "JOP-P0D-03-04" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "21/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-05" },
    { color: "BLUE", upc: "JOP-P0D-06-05" },
    { color: "GREEN", upc: "JOP-P0D-05-05" },
    { color: "ORANGE", upc: "JOP-P0D-04-05" },
    { color: "PINK", upc: "JOP-P0D-08-05" },
    { color: "PURPLE", upc: "JOP-P0D-09-05" },
    { color: "RED", upc: "JOP-P0D-07-05" },
    { color: "WHITE", upc: "JOP-P0D-02-05" },
    { color: "YELLOW", upc: "JOP-P0D-03-05" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "43/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-06" },
    { color: "BLUE", upc: "JOP-P0D-06-06" },
    { color: "GREEN", upc: "JOP-P0D-05-06" },
    { color: "ORANGE", upc: "JOP-P0D-04-06" },
    { color: "PINK", upc: "JOP-P0D-08-06" },
    { color: "PURPLE", upc: "JOP-P0D-09-06" },
    { color: "RED", upc: "JOP-P0D-07-06" },
    { color: "WHITE", upc: "JOP-P0D-02-06" },
    { color: "YELLOW", upc: "JOP-P0D-03-06" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "11/16",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-07" },
    { color: "BLUE", upc: "JOP-P0D-06-07" },
    { color: "GREEN", upc: "JOP-P0D-05-07" },
    { color: "ORANGE", upc: "JOP-P0D-04-07" },
    { color: "PINK", upc: "JOP-P0D-08-07" },
    { color: "PURPLE", upc: "JOP-P0D-09-07" },
    { color: "RED", upc: "JOP-P0D-07-07" },
    { color: "WHITE", upc: "JOP-P0D-02-07" },
    { color: "YELLOW", upc: "JOP-P0D-03-07" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "45/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-08" },
    { color: "BLUE", upc: "JOP-P0D-06-08" },
    { color: "GREEN", upc: "JOP-P0D-05-08" },
    { color: "ORANGE", upc: "JOP-P0D-04-08" },
    { color: "PINK", upc: "JOP-P0D-08-08" },
    { color: "PURPLE", upc: "JOP-P0D-09-08" },
    { color: "RED", upc: "JOP-P0D-07-08" },
    { color: "WHITE", upc: "JOP-P0D-02-08" },
    { color: "YELLOW", upc: "JOP-P0D-03-08" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "23/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-09" },
    { color: "BLUE", upc: "JOP-P0D-06-09" },
    { color: "GREEN", upc: "JOP-P0D-05-09" },
    { color: "ORANGE", upc: "JOP-P0D-04-09" },
    { color: "PINK", upc: "JOP-P0D-08-09" },
    { color: "PURPLE", upc: "JOP-P0D-09-09" },
    { color: "RED", upc: "JOP-P0D-07-09" },
    { color: "WHITE", upc: "JOP-P0D-02-09" },
    { color: "YELLOW", upc: "JOP-P0D-03-09" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "47/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-10" },
    { color: "BLUE", upc: "JOP-P0D-06-10" },
    { color: "GREEN", upc: "JOP-P0D-05-10" },
    { color: "ORANGE", upc: "JOP-P0D-04-10" },
    { color: "PINK", upc: "JOP-P0D-08-10" },
    { color: "PURPLE", upc: "JOP-P0D-09-10" },
    { color: "RED", upc: "JOP-P0D-07-10" },
    { color: "WHITE", upc: "JOP-P0D-02-10" },
    { color: "YELLOW", upc: "JOP-P0D-03-10" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "3/4",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-11" },
    { color: "BLUE", upc: "JOP-P0D-06-11" },
    { color: "GREEN", upc: "JOP-P0D-05-11" },
    { color: "ORANGE", upc: "JOP-P0D-04-11" },
    { color: "PINK", upc: "JOP-P0D-08-11" },
    { color: "PURPLE", upc: "JOP-P0D-09-11" },
    { color: "RED", upc: "JOP-P0D-07-11" },
    { color: "WHITE", upc: "JOP-P0D-02-11" },
    { color: "YELLOW", upc: "JOP-P0D-03-11" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "49/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-12" },
    { color: "BLUE", upc: "JOP-P0D-06-12" },
    { color: "GREEN", upc: "JOP-P0D-05-12" },
    { color: "ORANGE", upc: "JOP-P0D-04-12" },
    { color: "PINK", upc: "JOP-P0D-08-12" },
    { color: "PURPLE", upc: "JOP-P0D-09-12" },
    { color: "RED", upc: "JOP-P0D-07-12" },
    { color: "WHITE", upc: "JOP-P0D-02-12" },
    { color: "YELLOW", upc: "JOP-P0D-03-12" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "25/32",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-13" },
    { color: "BLUE", upc: "JOP-P0D-06-13" },
    { color: "GREEN", upc: "JOP-P0D-05-13" },
    { color: "ORANGE", upc: "JOP-P0D-04-13" },
    { color: "PINK", upc: "JOP-P0D-08-13" },
    { color: "PURPLE", upc: "JOP-P0D-09-13" },
    { color: "RED", upc: "JOP-P0D-07-13" },
    { color: "WHITE", upc: "JOP-P0D-02-13" },
    { color: "YELLOW", upc: "JOP-P0D-03-13" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "51/64",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-14" },
    { color: "BLUE", upc: "JOP-P0D-06-14" },
    { color: "GREEN", upc: "JOP-P0D-05-14" },
    { color: "ORANGE", upc: "JOP-P0D-04-14" },
    { color: "PINK", upc: "JOP-P0D-08-14" },
    { color: "PURPLE", upc: "JOP-P0D-09-14" },
    { color: "RED", upc: "JOP-P0D-07-14" },
    { color: "WHITE", upc: "JOP-P0D-02-14" },
    { color: "YELLOW", upc: "JOP-P0D-03-14" },
  ],
});

idx_data_insert_variants.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "13/16",
  variants: [
    { color: "BLACK", upc: "JOP-P0D-01-15" },
    { color: "BLUE", upc: "JOP-P0D-06-15" },
    { color: "GREEN", upc: "JOP-P0D-05-15" },
    { color: "ORANGE", upc: "JOP-P0D-04-15" },
    { color: "PINK", upc: "JOP-P0D-08-15" },
    { color: "PURPLE", upc: "JOP-P0D-09-15" },
    { color: "RED", upc: "JOP-P0D-07-15" },
    { color: "WHITE", upc: "JOP-P0D-02-15" },
    { color: "YELLOW", upc: "JOP-P0D-03-15" },
  ],
});

